// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-27T17:07:42.932Z
// Property: Mirador (ID: 6767906449167149)
// Collections: 21 amenities, 5 floorplans (live), 16 photos, 56 POIs, 4 reviews, 3 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167149",
  "property_external_id": "1125095",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/mirador-phoenix-az/8yb2zq1/",
  "property_google_business_url": "https://www.google.com/maps/place/Mirador/data=!4m2!3m1!1s0x0:0x24456bcc93c43064?sa=X&ved=2ahUKEwjbzNmS2YOTAxVaz_ACHRRvNysQ_BJ6BAgSEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47572542739",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "mirador",
  "property_name": "Mirador",
  "property_website_url": "https://www.miradorapartmenthomes.com",
  "property_domain": "https://www.miradorapartmenthomes.com",
  "property_address": "1550 East Thunderbird Rd",
  "property_full_address": "1550 E Thunderbird Rd, Phoenix, AZ 85022",
  "property_address_1": "1550 E Thunderbird Rd",
  "property_address_2": null,
  "property_address_city": "Phoenix",
  "property_address_state": "AZ",
  "property_address_zip_full": null,
  "property_address_zip": "85022",
  "property_address_country": "US",
  "property_address_county": "Maricopa County",
  "property_neighborhood_address": "Pointe Golf Club On Lookout Mountain",
  "property_address_latitude": "33.601717",
  "property_address_longitude": "-112.0465192",
  "property_email": "mirador@weidner.com",
  "property_phone": "9286688304",
  "property_call_tracking_phone": "928-339-3406",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Mirador in Phoenix, AZ, find your oasis among thoughtfully designed one, two, and three-bedroom apartments. Enjoy modern comforts like private patios, ceiling fans, and in-unit washers. Dive into relaxation by the pool or savor complimentary high-speed internet—your ideal living experience awaits. Check out our availability today!",
  "property_long_description": "Come home to relaxed, elegant living at Mirador Apartment Homes. Our apartments in Phoenix's Moon Valley neighborhood are in a vibrant area near the Paradise Valley Mall and the Pointe Hilton golf course and hotel. Mirador offers modern apartments with useful amenities in a warm and active community. It's also pet-friendly, has direct access to a walking path, and provides easy access to the light rail.Featuring all-in-pricing. One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d9313-cc53-722b-9e03-73acff8e14dc.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with a clubhouse in the background and palm trees.",
    "public_id": "019d9313-cc53-722b-9e03-73acff8e14dc",
    "storage_key": "property/6767906449167149/019d9313-cc53-722b-9e03-73acff8e14dc.webp",
    "width": 2560,
    "height": 936
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "316",
  "property_year_built": "1995",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.83544303797468",
  "property_admin_fee": null,
  "property_application_fee": "60",
  "property_fees_deposit_info": "300-450",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "200",
  "property_pet_deposit": "200",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://miradorapartmenthomes.securecafe.com/onlineleasing/mirador-3/floorplans.aspx",
  "property_resident_portal_url": "https://miradorapartmenthomes.securecafenet.com/residentservices/mirador-3/userlogin",
  "property_apply_now_url": "https://miradorapartmenthomes.securecafe.com/onlineleasing/mirador-3/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d9314-24b4-7761-9ef1-4e2c567cbfa1.webp",
  "property_primary_logo_media": {
    "alt_text": "Mirador Apartments logo",
    "public_id": "019d9314-24b4-7761-9ef1-4e2c567cbfa1",
    "storage_key": "property/6767906449167149/019d9314-24b4-7761-9ef1-4e2c567cbfa1.webp",
    "width": 308,
    "height": 75
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d9315-2137-778d-8c47-1f0afb179e5b.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Love notes logo",
    "public_id": "019d9315-2137-778d-8c47-1f0afb179e5b",
    "storage_key": "property/6767906449167149/019d9315-2137-778d-8c47-1f0afb179e5b.webp",
    "width": 308,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d9315-1615-72bf-aea5-b143922ec5e3.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Love notes logo",
    "public_id": "019d9315-1615-72bf-aea5-b143922ec5e3",
    "storage_key": "property/6767906449167149/019d9315-1615-72bf-aea5-b143922ec5e3.webp",
    "width": 308,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#f14151",
  "property_secondary_color": "#d9d6e0",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#2a3d54",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": " - 1201",
  "property_sqft_min": "754",
  "property_sqft_max": "1201",
  "property_price_range": "1277 - 3155",
  "property_price_min": "1277",
  "property_price_max": "3155",
  "property_available_units": 16,
  "property_facebook_url": "https://www.facebook.com/MiradorApartmentHomes/",
  "property_instagram_url": "https://www.instagram.com/miradorapthomes/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJfdRu_fVtK4cRZDDEk8xrRSQ",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Mirador",
  "property_home_romance_title": "Embrace Life and Love in Your Cozy New Apartment",
  "property_home_amenities_blurb": "Welcome to Mirador in vibrant Phoenix, AZ, where comfort meets convenience. Choose from our thoughtfully designed one, two, or three-bedroom layouts. Enjoy relaxing afternoons by the pool, cozy evenings by the fireplace, or savor the outdoors on your private patio. Live effortlessly with top-notch amenities like high-speed internet and in-home appliances.",
  "property_home_floorplans_blurb": "Welcome to Mirador, where vibrant Phoenix living meets stylish serenity. Our thoughtfully designed floor plans cater to every lifestyle, offering the perfect backdrop for your new home. Browse our available apartments and experience the blend of comfort and convenience waiting for you at Mirador. Your ideal living space is just a click away!",
  "property_home_gallery_blurb": "At Mirador in Phoenix, AZ, your ideal home awaits. Choose from one, two, or three-bedroom layouts, each designed for comfort and style. Enjoy exceptional amenities like a sparkling pool, private patio, and the convenience of high-speed internet on us. Picture yourself living here, where modern living meets serenity.",
  "property_home_neighborhood_blurb": "Welcome to Mirador, where modern living meets vibrant community life in Phoenix, AZ. Nestled near the breathtaking Piestewa Peak Trailhead and the scenic Phoenix Mountains Preserve, our one, two, and three-bedroom apartments offer a perfect blend of comfort and outdoor adventure. Live close to local gems like the Musical Instrument Museum and Castle N' Coasters for endless entertainment. See what’s around our community!",
  "property_home_reviews_blurb": "At Mirador in vibrant Phoenix, AZ, residents rave about their experience, stating, “The community feels like home with stunning views and friendly neighbors.” Don't just take our word for it—see what our residents have to say about living at our community! Join the Mirador family today!",
  "property_neighborhood_blurb": "At Mirador in vibrant Phoenix, AZ, life extends beyond your front door. Discover an array of recreational gems like the beautiful Piestewa Peak Trailhead and the scenic Phoenix Mountains Preserve. Dive into adventure with nearby attractions like Castles N' Coasters and the Musical Instrument Museum. Experience community living nestled amidst nature and entertainment. See what's around our community!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to Mirador in Phoenix, AZ, where modern living meets comfort. Choose from spacious one, two, or three-bedroom floor plans, each featuring delightful amenities like a refreshing pool, private balconies, and convenient in-home appliances. Enjoy the ease of high-speed internet and Cox Quick Connect, enhancing your living experience.",
  "property_applynow_blurb": "At Mirador in Phoenix, AZ, you’ll find spacious one, two, and three-bedroom apartments packed with modern conveniences. Imagine unwinding by the sparkling pool or enjoying your private patio. Plus, enjoy one month of complimentary high-speed internet, making remote working a breeze. Secure your new home—apply online today!",
  "property_contactus_blurb": "At Mirador in vibrant Phoenix, AZ, we offer a range of thoughtfully designed floor plans, from cozy one-bedroom retreats to spacious three-bedroom homes. Each layout is crafted for comfort and style. Have questions? Contact our leasing team today to find the perfect fit for your lifestyle!",
  "property_faqs_blurb": "At Mirador in vibrant Phoenix, AZ, we offer a variety of apartment layouts, from cozy one-bedroom havens to spacious three-bedroom retreats. Have questions? Our FAQs page is your go-to resource for insights about our community, helping you choose the perfect home tailored to your lifestyle. ",
  "property_floorplans_blurb": "At Mirador in Phoenix, AZ, every lifestyle finds its ideal match. Choose from our thoughtfully designed one, two, or three-bedroom floor plans that blend comfort and style. Ready to embark on your next chapter? Browse our available apartment homes to discover the perfect space for you!",
  "property_gallery_blurb": "At Mirador in Phoenix, AZ, your dream home awaits. With spacious one, two, and three-bedroom floor plans, plus amenities like a sparkling pool and cozy fireplace*, envision life adorned with modern comforts. Take a virtual stroll through our photo gallery—picture yourself thriving in this vibrant community!",
  "property_interactivemap_blurb": "At Mirador in Phoenix, AZ, luxury meets comfort with diverse floor plans, including one, two, and three-bedroom apartments. Enjoy amenities like a refreshing pool, private patios, and complimentary high-speed internet for a month. Dive into our interactive community map to find your ideal home today!",
  "property_pets_blurb": "At Mirador in sunny Phoenix, AZ, your furry friends are more than welcome! With no weight limits and a pet-friendly atmosphere, you can enjoy living with up to two pets. Let them relish spacious grounds while you savor modern comforts in your new home. Life at Mirador is pawesome!",
  "property_referafriend_blurb": "At Mirador in sunny Phoenix, AZ, you’ll find the perfect home to share with friends. Choose from our thoughtfully designed one, two, or three-bedroom floor plans, tailored for comfort and style. Great friends make great neighbors—refer a friend to our vibrant community today and enjoy life together!",
  "property_residentaccess_blurb": "Welcome to Mirador, your vibrant Phoenix retreat offering thoughtfully designed one, two, and three-bedroom floor plans. Enjoy seamless resident access to your portal for hassle-free rent payments, maintenance requests, and more. Embrace a community where comfort and convenience meet in the heart of Arizona!",
  "property_reviews_blurb": "At Mirador in vibrant Phoenix, AZ, residents rave about the \"comfortable atmosphere and friendly neighbors.\" Community spirit blends with modern amenities to create a truly welcoming home. See what our residents have to say about living at our community and experience the Mirador difference!",
  "property_created_at": "1771530634104",
  "property_scheduletour_blurb": "At Mirador in vibrant Phoenix, AZ, we offer a diverse selection of one, two, and three-bedroom floor plans that perfectly fit your lifestyle. Experience the unique charm of our community—schedule a tour today and hear firsthand from our residents about their exceptional living experience!",
  "property_thankyou_blurb": "Thank you for reaching out! At Mirador in vibrant Phoenix, AZ, we offer an array of thoughtfully designed floor plans—including one, two, and three-bedroom options—perfectly tailored to your lifestyle. Expect a prompt response from our team as you embark on your journey to find your dream home! ",
  "property_virtualtours_blurb": "Step into comfort and style at Mirador in vibrant Phoenix, AZ. Choose from our thoughtfully designed one, two, or three-bedroom apartments, each tailored to meet your unique lifestyle. Picture yourself here and immerse in the experience—take a virtual tour of our community and apartments for rent today!",
  "property_copyright": "2026 All Rights Reserved. Mirador",
  "property_seo_title_home": "Mirador |  Apartments in Phoenix, AZ",
  "property_seo_description_home": "Discover vibrant living at Mirador in Phoenix, AZ! Choose from spacious 1-3 bedroom plans and enjoy amazing amenities. Your ideal home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Phoenix, AZ Apartments for Rent",
  "property_seo_description_floorplans": "Uncover the ideal space at Mirador in Phoenix, AZ. Choose from one, two, or three-bedroom floor plans tailored to your lifestyle. Your new home awaits!",
  "property_seo_title_amenities": "Amenities | Phoenix, AZ Apartments for Rent",
  "property_seo_description_amenities": "Elevate your lifestyle at Mirador in Phoenix! Enjoy spacious one to three-bedroom homes, a refreshing pool, and special perks like free high-speed internet.",
  "property_seo_title_gallery": "Gallery | Apartments in Phoenix, AZ",
  "property_seo_description_gallery": "Picture life at Mirador in Phoenix! Choose from spacious one, two, or three-bedroom plans, enjoy luxurious amenities, and imagine your perfect getaway.",
  "property_seo_title_virtualtours": "Virtual Tours | Mirador Apartments",
  "property_seo_description_virtualtours": "Step inside Mirador in Phoenix, AZ! Experience our stunning one, two, and three-bedroom apartments. Take a virtual tour today and envision your new home!",
  "property_seo_title_interactivemap": "Interactive Map | Mirador Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at Mirador in Phoenix, AZ! Explore our interactive map for one, two, and three-bedroom floor plans and amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Phoenix, AZ",
  "property_seo_description_neighborhood": "Uncover the vibrant life around Mirador in Phoenix, AZ! Dive into local favorites, scenic spots, and hidden gems just steps from your new home.",
  "property_seo_title_contact": "Contact Us | Mirador",
  "property_seo_description_contact": "Reach out to Mirador in Phoenix for any inquiries about our one, two, and three-bedroom apartments. Your new home awaits—let's connect today!",
  "property_seo_title_faqs": "FAQs | Apartments in Phoenix, AZ",
  "property_seo_description_faqs": "Uncover your ideal living space at Mirador in Phoenix, AZ! Get answers to common questions and find out about our one, two, and three-bedroom options today.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Phoenix, AZ",
  "property_seo_description_reviews": "Experience life at Mirador in Phoenix, AZ! Unwind by the pool, enjoy amenities like high-speed internet, and read resident reviews to feel at home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Phoenix, AZ",
  "property_seo_description_applynow": "Elevate your lifestyle at Mirador in Phoenix! Enjoy spacious floor plans, a sparkling pool, and exclusive internet offers. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Mirador",
  "property_seo_description_residentaccess": "Login to Mirador's resident portal in Phoenix, AZ, for easy rent payments, maintenance requests, and community updates. Your seamless living experience awaits!",
  "property_seo_title_referafriend": "Refer A Friend | Mirador",
  "property_seo_description_referafriend": "At Mirador in Phoenix, great friends make great neighbors! Refer a friend today and enhance your vibrant community experience together. Join us now!",
  "property_seo_title_scheduletour": "Schedule a Tour | Mirador",
  "property_seo_description_scheduletour": "Discover the charm of Mirador in Phoenix! Schedule a tour to find your ideal home in a vibrant community with stunning amenities and views.",
  "property_seo_title_privacy": "Privacy Policy | Mirador",
  "property_seo_description_privacy": "Protecting your privacy is our priority at Mirador. Learn how we safeguard your information while you enjoy vibrant living in Phoenix. View our policy now!",
  "property_seo_title_accessibility": "Website Accessibility | Mirador",
  "property_seo_description_accessibility": "Experience accessibility at Mirador in Phoenix, AZ. We prioritize digital inclusion, ensuring everyone can enjoy our vibrant community. Join us today!",
  "property_seo_title_sitemap": "Sitemap | Mirador",
  "property_seo_description_sitemap": "Unveil the layout of Mirador in Phoenix, AZ. Check our sitemap for easy navigation, and find your perfect home among our vibrant community offerings!",
  "property_seo_title_thankyou": "Thank You | Mirador",
  "property_seo_description_thankyou": "Thank you for your interest in Mirador! Our team in Phoenix will connect soon to help you find your perfect apartment home. Stay tuned for exciting updates!",
  "property_seo_title_pets": "Pet Policy | Apartments in Phoenix, AZ",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293659594",
  "amenities": [
    {
      "id": "ec_6760d1c614a086c2ed9a43cb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "yardi",
      "external_id": "107042223",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d0217-c56c-7427-a7a2-a2d6aed61eb4.webp",
      "amenity_image_media": {
        "alt_text": "Resort-style swimming pool with palm trees and a cabana.",
        "public_id": "019d0217-c56c-7427-a7a2-a2d6aed61eb4",
        "storage_key": "property/6767906449167149/019d0217-c56c-7427-a7a2-a2d6aed61eb4.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "a swimming pool in front of a house with palm trees in the background,a house with a swimming pool in the backyard",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d5631bdb41cd63b589a8c4bf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "yardi",
      "external_id": "87564747",
      "title": "Fitness Center",
      "amount": "false",
      "description": "Open 8 AM - 10 PM Daily",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d0217-cd07-73fc-be6d-4a73a7d665c7.webp",
      "amenity_image_media": {
        "alt_text": "Treadmills, recumbent bike, dumbbells, and weight machines in a well-equipped fitness center.",
        "public_id": "019d0217-cd07-73fc-be6d-4a73a7d665c7",
        "storage_key": "property/6767906449167149/019d0217-cd07-73fc-be6d-4a73a7d665c7.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "the colony at deerwood apartments cardio room",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0cce4538bb3411fd10f2d62a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "yardi",
      "external_id": "87564758",
      "title": "Spa/hot tub",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d0217-c7ee-756c-a612-e9b0a9b4225e.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor spa with caution signs.",
        "public_id": "019d0217-c7ee-756c-a612-e9b0a9b4225e",
        "storage_key": "property/6767906449167149/019d0217-c7ee-756c-a612-e9b0a9b4225e.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "a hot tub with a fence and trees in the background",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bc83b9c95dc0b195c33d63bc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "yardi",
      "external_id": "97071054",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d0217-d17f-7697-bf1e-3d0139d358e7.webp",
      "amenity_image_media": {
        "alt_text": "Living room with fireplace, modern furniture, and large windows overlooking the pool area.",
        "public_id": "019d0217-d17f-7697-bf1e-3d0139d358e7",
        "storage_key": "property/6767906449167149/019d0217-d17f-7697-bf1e-3d0139d358e7.webp",
        "width": 1526,
        "height": 1019
      },
      "amenity_image_alt_text": "a living room filled with furniture and a large window",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3ead6a15ef397531bf36c2a2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "yardi",
      "external_id": "87564757",
      "title": "Reserved Covered Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e7f682e7162bd4e976fa3261",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "yardi",
      "external_id": "87564748",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_466174a9b6f49ac2c04f7cec",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "yardi",
      "external_id": "87564749",
      "title": "BBQ & picnic areas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_277337e6a3f8bef24e3d8b81",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "yardi",
      "external_id": "87564751",
      "title": "Gated entrance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e104a9f13bb74ffef441ecde",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "yardi",
      "external_id": "87564746",
      "title": "Online Payments Available",
      "amount": "false",
      "description": "Free e-check option\r\nAccepts credit card payments\r\nAccepts cash payments via MoneyGram",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2d86746e5c5f97091df0af1a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "yardi",
      "external_id": "87564750",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b0e76ddb6a2ffe34796e6585",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "yardi",
      "external_id": "87564752",
      "title": "Golf course and mountain views",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1658a569287b34d28b009ae9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "yardi",
      "external_id": "87564754",
      "title": "Online Maintenance Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d6c479c6adbf32418f6e5d40",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "yardi",
      "external_id": "87564756",
      "title": "Dog and Cat Friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ce5260ba2483dbc1651cea65",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "yardi",
      "external_id": "87564759",
      "title": "Walking trails",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e57145dabb44494d5bc26b25",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "yardi",
      "external_id": "88069599",
      "title": "Smoke-Free Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c81f51cacfe4eb0f642710d6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "yardi",
      "external_id": "87564760",
      "title": "Ceiling Fans in Living Room*",
      "amount": "false",
      "description": "*Additional ceiling fans can be installed upon request for an additional fee",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d0217-c227-779f-a05e-367bd3715a6a.webp",
      "amenity_image_media": {
        "alt_text": "A home office with a desk, chair, and bookshelf, adjacent to a living area with a sofa and floor lamp.",
        "public_id": "019d0217-c227-779f-a05e-367bd3715a6a",
        "storage_key": "property/6767906449167149/019d0217-c227-779f-a05e-367bd3715a6a.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "a living room with a couch and a desk with a chair in front of a large window,a living room with a large window and a ceiling fan",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7cc1e4c337c3cfc05a6c0365",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "yardi",
      "external_id": "87564765",
      "title": "Private Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d192d4db9b0e9983f87fc0f2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "yardi",
      "external_id": "87564761",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a57e180f7f937c2ab23fa318",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "yardi",
      "external_id": "87564763",
      "title": "Full Size Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ee75372c77b727999d641d2d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "yardi",
      "external_id": "87564764",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0f7f3f40eb2aa945d5b9c0ce",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "yardi",
      "external_id": "88577812",
      "title": "1 Month of Free High-Speed Internet Courtesy of Spectrum Communications",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d0217-fe4e-735a-85ec-6cb6f524b320.webp",
      "amenity_image_media": {
        "alt_text": "Text overlay: Homes Wi-Fi ready with pre-installed modem/router and first month free provided by Cox!",
        "public_id": "019d0217-fe4e-735a-85ec-6cb6f524b320",
        "storage_key": "property/6767906449167149/019d0217-fe4e-735a-85ec-6cb6f524b320.webp",
        "width": 2500,
        "height": 1668
      },
      "amenity_image_alt_text": "1 Month of Free High-Speed Internet",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_aba464d6bdede4dbad80a99e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d0217-aee4-75c1-be85-3d6551ba9668.webp",
      "image_media": {
        "alt_text": "Living room with beige sofa, armchairs, coffee table, and ceiling fan.",
        "public_id": "019d0217-aee4-75c1-be85-3d6551ba9668",
        "storage_key": "property/6767906449167149/019d0217-aee4-75c1-be85-3d6551ba9668.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Relax and unwind in the spacious living area, featuring comfortable seating, a stylish coffee table, and a ceiling fan for your comfort.",
      "link": "false",
      "alt_text": "Living room with beige sofa, armchairs, coffee table, and ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Mirador_Favorites (1).jpg"
    },
    {
      "id": "ec_372affed62bb7cfc706b83ce",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d0217-adc0-75ff-b4c5-3ad5f571b8d3.webp",
      "image_media": {
        "alt_text": "Dining area with glass-top table and four chairs, next to kitchen entrance.",
        "public_id": "019d0217-adc0-75ff-b4c5-3ad5f571b8d3",
        "storage_key": "property/6767906449167149/019d0217-adc0-75ff-b4c5-3ad5f571b8d3.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Enjoy a dedicated dining area, perfect for meals or entertaining guests. Adjacent to the kitchen for convenience.",
      "link": "false",
      "alt_text": "Dining area with glass-top table and four chairs, next to kitchen entrance.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Mirador_Favorites (2).jpg"
    },
    {
      "id": "ec_24b47c0b5d433b5f27efbe2d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d0217-aee4-75c1-be85-37cf774d2823.webp",
      "image_media": {
        "alt_text": "Kitchen counter space with a double sink and cabinets, looking into the living room.",
        "public_id": "019d0217-aee4-75c1-be85-37cf774d2823",
        "storage_key": "property/6767906449167149/019d0217-aee4-75c1-be85-37cf774d2823.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Modern kitchen with ample counter space, a double sink, and light wood cabinets, seamlessly opening into a well-lit living area.",
      "link": "false",
      "alt_text": "Kitchen counter space with a double sink and cabinets, looking into the living room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Mirador_Favorites (3).jpg"
    },
    {
      "id": "ec_f4cadc98d856f843ba9f15ba",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d0217-b7c1-7109-b634-0c4620c74798.webp",
      "image_media": {
        "alt_text": "Corner kitchen with light wood cabinets, black appliances, and granite countertops.",
        "public_id": "019d0217-b7c1-7109-b634-0c4620c74798",
        "storage_key": "property/6767906449167149/019d0217-b7c1-7109-b634-0c4620c74798.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "A clean and functional kitchen space featuring ample cabinet storage, modern black appliances, and durable granite countertops, perfect for everyday cooking.",
      "link": "false",
      "alt_text": "Corner kitchen with light wood cabinets, black appliances, and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Mirador_Favorites (4).jpg"
    },
    {
      "id": "ec_af5784aa192df8fcdb5fcd05",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d0217-b9bb-71ee-ba8d-4ad54768506e.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a king-size bed, plush bedding, and a ceiling fan.",
        "public_id": "019d0217-b9bb-71ee-ba8d-4ad54768506e",
        "storage_key": "property/6767906449167149/019d0217-b9bb-71ee-ba8d-4ad54768506e.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush king-size bed and elegant decor.",
      "link": "false",
      "alt_text": "Cozy bedroom with a king-size bed, plush bedding, and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Mirador_Favorites (5).jpg"
    },
    {
      "id": "ec_3885c7afb5729612ba03627f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d0217-baac-745d-af3e-7dc1cff8f641.webp",
      "image_media": {
        "alt_text": "Bathroom vanity, walk-in closet, and bathtub with shower",
        "public_id": "019d0217-baac-745d-af3e-7dc1cff8f641",
        "storage_key": "property/6767906449167149/019d0217-baac-745d-af3e-7dc1cff8f641.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity, a walk-in closet with ample storage, and a separate shower and tub area.",
      "link": "false",
      "alt_text": "Bathroom vanity, walk-in closet, and bathtub with shower",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Mirador_Favorites (6).jpg"
    },
    {
      "id": "ec_d0517d45c2f85d34c4fda976",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d0217-ba88-7181-80d0-c6f5a8c52941.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a bathtub, shower, toilet, and vanity.",
        "public_id": "019d0217-ba88-7181-80d0-c6f5a8c52941",
        "storage_key": "property/6767906449167149/019d0217-ba88-7181-80d0-c6f5a8c52941.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Step into a clean and functional bathroom featuring a tiled bathtub and shower, a modern vanity with a sink, and a toilet.",
      "link": "false",
      "alt_text": "Modern bathroom with a bathtub, shower, toilet, and vanity.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Mirador_Favorites (7).jpg"
    },
    {
      "id": "ec_08c51c98dd7aee7b4966e149",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d0217-c227-779f-a05e-367bd3715a6a.webp",
      "image_media": {
        "alt_text": "A home office with a desk, chair, and bookshelf, adjacent to a living area with a sofa and floor lamp.",
        "public_id": "019d0217-c227-779f-a05e-367bd3715a6a",
        "storage_key": "property/6767906449167149/019d0217-c227-779f-a05e-367bd3715a6a.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Create a productive workspace and a comfortable living area within your apartment. This versatile space features a dedicated home office setup and a cozy seating area perfect for relaxation.",
      "link": "false",
      "alt_text": "A home office with a desk, chair, and bookshelf, adjacent to a living area with a sofa and floor lamp.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Mirador_Favorites (8).jpg"
    },
    {
      "id": "ec_d054d948d50e010f1e3be3e6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d0217-c56c-7427-a7a2-a2d6aed61eb4.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with palm trees and a cabana.",
        "public_id": "019d0217-c56c-7427-a7a2-a2d6aed61eb4",
        "storage_key": "property/6767906449167149/019d0217-c56c-7427-a7a2-a2d6aed61eb4.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by lush palm trees and comfortable lounge areas. Perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with palm trees and a cabana.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Mirador_Favorites (9).jpg"
    },
    {
      "id": "ec_907b7f229756b56cc25e5e8a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d0217-c7ee-756c-a612-e9b0a9b4225e.webp",
      "image_media": {
        "alt_text": "Outdoor spa with caution signs.",
        "public_id": "019d0217-c7ee-756c-a612-e9b0a9b4225e",
        "storage_key": "property/6767906449167149/019d0217-c7ee-756c-a612-e9b0a9b4225e.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Relax and unwind in the community spa, perfect for a rejuvenating soak.",
      "link": "false",
      "alt_text": "Outdoor spa with caution signs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Mirador_Favorites (10).jpg"
    },
    {
      "id": "ec_b8a033ca24bdf71d11157b27",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d0217-cd07-73fc-be6d-4a73a7d665c7.webp",
      "image_media": {
        "alt_text": "Treadmills, recumbent bike, dumbbells, and weight machines in a well-equipped fitness center.",
        "public_id": "019d0217-cd07-73fc-be6d-4a73a7d665c7",
        "storage_key": "property/6767906449167149/019d0217-cd07-73fc-be6d-4a73a7d665c7.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring cardio machines, free weights, and strength-training equipment.",
      "link": "false",
      "alt_text": "Treadmills, recumbent bike, dumbbells, and weight machines in a well-equipped fitness center.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Mirador_Favorites (11).jpg"
    },
    {
      "id": "ec_626a12043121f4b16d005eca",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d0217-d17f-7697-bf1e-3d0139d358e7.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, modern furniture, and large windows overlooking the pool area.",
        "public_id": "019d0217-d17f-7697-bf1e-3d0139d358e7",
        "storage_key": "property/6767906449167149/019d0217-d17f-7697-bf1e-3d0139d358e7.webp",
        "width": 1526,
        "height": 1019
      },
      "title": "Apartment",
      "description": "Relax in the stylish living room featuring a cozy fireplace, plush seating, and scenic views of the outdoor pool and surrounding landscape. Perfect for unwinding.",
      "link": "false",
      "alt_text": "Living room with fireplace, modern furniture, and large windows overlooking the pool area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Mirador_Favorites (12).jpg"
    },
    {
      "id": "ec_0e29da34d8271870d6feda66",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d0217-d41d-776f-b545-51e015bb896b.webp",
      "image_media": {
        "alt_text": "Modern lounge area with comfortable seating and views of the pool.",
        "public_id": "019d0217-d41d-776f-b545-51e015bb896b",
        "storage_key": "property/6767906449167149/019d0217-d41d-776f-b545-51e015bb896b.webp",
        "width": 1531,
        "height": 1022
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lounge, featuring plush seating and large windows overlooking the resort-style pool. Perfect for socializing or quiet contemplation.",
      "link": "false",
      "alt_text": "Modern lounge area with comfortable seating and views of the pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Mirador_Favorites (13).jpg"
    },
    {
      "id": "ec_a33223c272234b41fbd2d50e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d0217-d41c-764a-9a73-5231b5b8b40b.webp",
      "image_media": {
        "alt_text": "Business center with computers, tables, chairs, and artwork.",
        "public_id": "019d0217-d41c-764a-9a73-5231b5b8b40b",
        "storage_key": "property/6767906449167149/019d0217-d41c-764a-9a73-5231b5b8b40b.webp",
        "width": 1536,
        "height": 1025
      },
      "title": "Community",
      "description": "Enjoy our modern business center, equipped with computers and comfortable seating for your productivity needs.",
      "link": "false",
      "alt_text": "Business center with computers, tables, chairs, and artwork.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Mirador_Favorites (14).jpg"
    },
    {
      "id": "ec_eee0ddeda46ed69b1de38a38",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d0217-d89f-7497-901d-7e5a330ab11b.webp",
      "image_media": {
        "alt_text": "Covered patio with seating and a grill, overlooking the property grounds.",
        "public_id": "019d0217-d89f-7497-901d-7e5a330ab11b",
        "storage_key": "property/6767906449167149/019d0217-d89f-7497-901d-7e5a330ab11b.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Enjoy outdoor living in our community's covered patio area, complete with a grill and seating for al fresco dining.",
      "link": "false",
      "alt_text": "Covered patio with seating and a grill, overlooking the property grounds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Mirador_Favorites (15).jpg"
    },
    {
      "id": "ec_293669b4879147195789c0af",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019efd6b-82db-779b-af8d-60c85db19093.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and golf course in the background.",
        "public_id": "019efd6b-82db-779b-af8d-60c85db19093",
        "storage_key": "property/6767906449167149/019efd6b-82db-779b-af8d-60c85db19093.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Aerial view of apartment buildings showcasing the property's exterior, pool area, and proximity to a golf course.",
      "link": "false",
      "alt_text": "Aerial view of apartment buildings with a pool and golf course in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/DJI_0062 copy.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_b6cc9224-8ebe-4e50-9346-e274a920f557",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Bobby-Q BBQ Restaurant and Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "8501 N 27th Ave, Phoenix, AZ 85051, USA",
      "poi_short_description": "Family-friendly eatery serving steak, BBQ ribs & other American comfort items in a rustic setting.",
      "poi_long_description": "People say this barbecue restaurant serves delicious ribs, brisket, and pulled pork, and the Q rolls and cornbread are highly recommended. They highlight the generous portions, reasonable prices, and the complimentary donuts at the end of the meal. They also like the friendly and attentive service, and the fun, lively atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-e731-704a-9f7e-76ba03214776.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-e731-704a-9f7e-76ba03214776",
        "storage_key": "property/6767906449167149/019d021b-e731-704a-9f7e-76ba03214776.webp",
        "width": 1124,
        "height": 634
      },
      "poi_business_url": "https://bobbyqbbq.com/phoenix-bbq-restaurant/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11940719194717959783&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bobby-q-bbq-restaurant-and-steakhouse",
      "poi_latitude": "33.560937",
      "poi_longitude": "-112.1158642",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 602-995-5982",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-a801-762c-a57d-12f2948e40f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-a801-762c-a57d-12f2948e40f4",
        "storage_key": "property/6767906449167149/019d021b-a801-762c-a57d-12f2948e40f4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8dBh__RsK4cRZzbay9f0taU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_68de5cfc-c142-467c-ac44-76cdba7b37ad",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Pappadeaux Seafood Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "11051 N Black Cyn Hwy, Phoenix, AZ 85029, USA",
      "poi_short_description": "Cajun-style seafood, pastas & comfort fare served in a dark wood eatery with a full bar.",
      "poi_long_description": "People say this seafood restaurant serves fresh and flavorful seafood, including gumbo, shrimp salad, and crab cakes. They highlight the generous portions, the lively and beautiful atmosphere, and the attentive service. They also like the outdoor water fountain and surrounding plant life.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-e71b-7357-a5e2-2f895cfce73c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-e71b-7357-a5e2-2f895cfce73c",
        "storage_key": "property/6767906449167149/019d021b-e71b-7357-a5e2-2f895cfce73c.webp",
        "width": 886,
        "height": 349
      },
      "poi_business_url": "https://pappadeaux.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13477599013761038707&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pappadeaux-seafood-kitchen",
      "poi_latitude": "33.587819",
      "poi_longitude": "-112.1158724",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 602-331-3434",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-a801-762c-a57d-12f2948e40f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-a801-762c-a57d-12f2948e40f4",
        "storage_key": "property/6767906449167149/019d021b-a801-762c-a57d-12f2948e40f4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8Wnq1T1sK4cRc7lhSOUMCrs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_c55fcf52-317f-4cec-92a2-c743ebc61813",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Little Miss BBQ-Sunnyslope",
      "poi_type": "Restaurants",
      "poi_address": "8901 N 7th St, Phoenix, AZ 85020, USA",
      "poi_short_description": "Barbecue specialty shop for brisket and other smoked meats and sides, plus beer and wine.",
      "poi_long_description": "People say this barbecue restaurant serves tender brisket, flavorful ribs, and delicious sides like mac and cheese and jalapeño cheddar grits. They highlight the generous portions, the smoky aroma, and the friendly and hospitable staff. They also like the clean and spacious dining area, and the large patio with misters.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-e980-7138-81f6-24a4175a25c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-e980-7138-81f6-24a4175a25c5",
        "storage_key": "property/6767906449167149/019d021b-e980-7138-81f6-24a4175a25c5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.littlemissbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4179398957250748695&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "little-miss-bbq-sunnyslope",
      "poi_latitude": "33.566205",
      "poi_longitude": "-112.064784",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 602-314-6922",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-a801-762c-a57d-12f2948e40f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-a801-762c-a57d-12f2948e40f4",
        "storage_key": "property/6767906449167149/019d021b-a801-762c-a57d-12f2948e40f4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZds6MIptK4cRF6GRTTU1ADo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_b0d82fec-18a5-4948-85f5-73288858159f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Culinary Dropout",
      "poi_type": "Restaurants",
      "poi_address": "5632 N 7th St, Phoenix, AZ 85014, USA",
      "poi_short_description": "Cool, British-style gastropub chain with quirky decor, serving inventive cocktails & comfort food.",
      "poi_long_description": "Diners say this American restaurant serves up delicious brussel sprouts, fried chicken, fish and chips, and pretzel bites, and they praise the lively atmosphere with outdoor seating, cornhole, and ping pong. They also highlight the friendly and attentive service, and many appreciate the complimentary valet parking.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-e71b-7357-a5e2-25735b76ae37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-e71b-7357-a5e2-25735b76ae37",
        "storage_key": "property/6767906449167149/019d021b-e71b-7357-a5e2-25735b76ae37.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.culinarydropout.com/locations/phoenix-az/?utm_source=Google&utm_medium=Organic&utm_campaign=Maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=2103499372696634781&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "culinary-dropout",
      "poi_latitude": "33.519589",
      "poi_longitude": "-112.0654512",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 602-680-4040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-a801-762c-a57d-12f2948e40f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-a801-762c-a57d-12f2948e40f4",
        "storage_key": "property/6767906449167149/019d021b-a801-762c-a57d-12f2948e40f4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJh6g1AroSK4cRnQXX3oghMR0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_d06e54f4-a258-4aef-9d90-bc1136871e98",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "In-N-Out Burger",
      "poi_type": "Restaurants",
      "poi_address": "2770 W Peoria Ave, Phoenix, AZ 85029, USA",
      "poi_short_description": "Classic burger chain serving customizable burgers, hand-cut fries & shakes.",
      "poi_long_description": "People say this hamburger restaurant serves amazing burgers and fries, with animal style fries being a popular choice. They highlight the fresh ingredients, made-to-order food, and reasonable prices. They also like the fast and efficient service, and the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-edf8-7399-8dce-8590cc872f73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-edf8-7399-8dce-8590cc872f73",
        "storage_key": "property/6767906449167149/019d021b-edf8-7399-8dce-8590cc872f73.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.in-n-out.com/252",
      "poi_directions_map_url": "https://maps.google.com/?cid=10941012962621747436&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-n-out-burger",
      "poi_latitude": "33.5823883",
      "poi_longitude": "-112.1198743",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 800-786-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-a801-762c-a57d-12f2948e40f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-a801-762c-a57d-12f2948e40f4",
        "storage_key": "property/6767906449167149/019d021b-a801-762c-a57d-12f2948e40f4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW0WTI7lMw4AR7HADUFJJ1pc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_2855e6d1-0ccc-48bc-9020-30621184ae67",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "12500 N Tatum Blvd, Phoenix, AZ 85032, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "Shoppers say this grocery store offers a wide selection of products including fresh produce, a salad bar, a soup bar, a coffee shop, a meat and fish counter, and a cheese counter. They also highlight the friendly and helpful staff, the clean and well-organized store, and the convenient Amazon return service.\n\nSome reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-edd1-77db-9254-2f129ba5dacd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-edd1-77db-9254-2f129ba5dacd",
        "storage_key": "property/6767906449167149/019d021b-edd1-77db-9254-2f129ba5dacd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/paradisevalley?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=5131056267076541453&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "33.6015369",
      "poi_longitude": "-111.981181",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 602-569-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-ae90-76b9-aa55-ad18cc6a102b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-ae90-76b9-aa55-ad18cc6a102b",
        "storage_key": "property/6767906449167149/019d021b-ae90-76b9-aa55-ad18cc6a102b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIZ6VgQxzK4cRDZyjSX0sNUc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_444a0aa4-5045-4d8b-b73d-06fed76c7351",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "330 W Bell Rd, Phoenix, AZ 85023, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "People say this supermarket offers a wide selection of fresh produce, meat, and bulk items, including spices, candy, and baking supplies. They highlight the low prices, convenient 24-hour opening hours, and self-checkout option. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-ef83-757a-bcd8-06bfe3f9ec50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-ef83-757a-bcd8-06bfe3f9ec50",
        "storage_key": "property/6767906449167149/019d021b-ef83-757a-bcd8-06bfe3f9ec50.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14777022528232851537&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "33.641162",
      "poi_longitude": "-112.079758",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 602-978-2730",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-ae90-76b9-aa55-ad18cc6a102b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-ae90-76b9-aa55-ad18cc6a102b",
        "storage_key": "property/6767906449167149/019d021b-ae90-76b9-aa55-ad18cc6a102b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMaQMRERuK4cRUYhDibKHEs0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_9807aafc-8c1a-40b2-9306-067dceabab14",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Bookmans Phoenix Entertainment Exchange",
      "poi_type": "Shopping & Retail",
      "poi_address": "8034 N 19th Ave, Phoenix, AZ 85021, USA",
      "poi_short_description": "Established business buying, selling & trading used books, music, movies, video games & instruments.",
      "poi_long_description": "People say this used book store offers a wide array of media and book options, including books, CDs, vinyl, video games, instruments, toys, and knick-knacks. They highlight the store is fun, comfortable, and inviting, with a huge selection and organized layout. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-ef84-74e7-9751-0a547f3a6e8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-ef84-74e7-9751-0a547f3a6e8d",
        "storage_key": "property/6767906449167149/019d021b-ef84-74e7-9751-0a547f3a6e8d.webp",
        "width": 1084,
        "height": 614
      },
      "poi_business_url": "http://www.bookmans.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16140797074585927479&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bookmans-phoenix-entertainment-exchange",
      "poi_latitude": "33.5542174",
      "poi_longitude": "-112.1010025",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 602-433-0255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-ac98-7579-a2cb-5f6e90fd0f65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-ac98-7579-a2cb-5f6e90fd0f65",
        "storage_key": "property/6767906449167149/019d021b-ac98-7579-a2cb-5f6e90fd0f65.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ2RiWEuNsK4cRN79b9muh_98",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "book_store"
    },
    {
      "id": "custom_45abc861-c6f8-44dd-bf56-6c09b2b4b876",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "4726 E Shea Blvd, Phoenix, AZ 85028, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers a wide variety of unique foods, snacks, desserts, and fresh produce, as well as a selection of flowers and plants. They highlight the reasonable prices, clean and bright shop floor, and fun, relaxed atmosphere. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-f446-72ab-b05e-3e0b676e37ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-f446-72ab-b05e-3e0b676e37ad",
        "storage_key": "property/6767906449167149/019d021b-f446-72ab-b05e-3e0b676e37ad.webp",
        "width": 1280,
        "height": 606
      },
      "poi_business_url": "https://locations.traderjoes.com/az/phoenix/282/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=1465589481282643636&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "33.5833102",
      "poi_longitude": "-111.9790307",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 602-485-7788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-ae90-76b9-aa55-ad18cc6a102b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-ae90-76b9-aa55-ad18cc6a102b",
        "storage_key": "property/6767906449167149/019d021b-ae90-76b9-aa55-ad18cc6a102b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6xL4jgtzK4cRtKZmQt7RVhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_0fb43995-e4d3-401f-a466-45675c2fce8d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "2650 W Thunderbird Rd, Phoenix, AZ 85023, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide selection of building materials, home decor, appliances, and garden supplies. They also highlight the helpful and knowledgeable staff, and the clean and well-stocked store.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-f640-71ad-b86b-7fc4f132493d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-f640-71ad-b86b-7fc4f132493d",
        "storage_key": "property/6767906449167149/019d021b-f640-71ad-b86b-7fc4f132493d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/Thunderbird/AZ/Phoenix/85023/468?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=14417292861994138626&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "33.612414",
      "poi_longitude": "-112.1146686",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 602-548-9600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-ac98-7579-a2cb-5f6e90fd0f65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-ac98-7579-a2cb-5f6e90fd0f65",
        "storage_key": "property/6767906449167149/019d021b-ac98-7579-a2cb-5f6e90fd0f65.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJB--oB5xuK4cRAnzvzXiDFMg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_b8592e57-6788-4c78-bac8-e2c10584579a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Paradise Valley Community College",
      "poi_type": "Education",
      "poi_address": "18401 N 32nd St, Phoenix, AZ 85032, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-6b89-74ca-8268-f9841d642e52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-6b89-74ca-8268-f9841d642e52",
        "storage_key": "property/6767906449167149/019d021b-6b89-74ca-8268-f9841d642e52.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "https://www.paradisevalley.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13987215222963963332&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "paradise-valley-community-college",
      "poi_latitude": "33.6530707",
      "poi_longitude": "-112.0107061",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 602-787-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-b0a5-708b-84de-5e50e09cdc57.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-b0a5-708b-84de-5e50e09cdc57",
        "storage_key": "property/6767906449167149/019d021b-b0a5-708b-84de-5e50e09cdc57.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJg5CBn6RxK4cRxAW0SSOSHMI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_bbdd7322-fb71-40be-9335-c5ab8d03529a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Musical Instrument Museum",
      "poi_type": "Entertainment",
      "poi_address": "4725 E Mayo Blvd, Phoenix, AZ 85050, USA",
      "poi_short_description": "Expansive display of instruments from roughly 200 countries, including some that guests can try out.",
      "poi_long_description": "Visitors say this museum offers an immersive experience with interactive exhibits, a vast collection of musical instruments from around the world, and a special exhibit featuring Stradivarius violins and guitars. They also highlight the friendly and helpful staff, the engaging audio tour, and the beautiful building and grounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-72dc-75c5-a713-ab04ee79dec3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-72dc-75c5-a713-ab04ee79dec3",
        "storage_key": "property/6767906449167149/019d021b-72dc-75c5-a713-ab04ee79dec3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://mim.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3729350831455392251&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "musical-instrument-museum",
      "poi_latitude": "33.6679904",
      "poi_longitude": "-111.9782969",
      "poi_miles_from_property": "9",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 480-478-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-b339-7591-9254-0a01a35614af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-b339-7591-9254-0a01a35614af",
        "storage_key": "property/6767906449167149/019d021b-b339-7591-9254-0a01a35614af.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJfTp55hhxK4cR-9G0f9JQwTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_cf668881-1f28-4244-84bc-086d3105384e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Castles N' Coasters",
      "poi_type": "Entertainment",
      "poi_address": "9445 N Metro Pkwy E, Phoenix, AZ 85051, USA",
      "poi_short_description": "Family-friendly destination for mini-golf, go-kart rides, roller coasters & an arcade.",
      "poi_long_description": "People say this amusement park offers a variety of fun rides, mini golf courses, and arcade games. They also highlight the reasonable prices, especially with the unlimited ride pass, and the fun, family-friendly atmosphere.\n\nOther reviews mention the rides can be closed during certain times.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-77c6-75d0-ba9b-9d35a8ae8f83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-77c6-75d0-ba9b-9d35a8ae8f83",
        "storage_key": "property/6767906449167149/019d021b-77c6-75d0-ba9b-9d35a8ae8f83.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.castlesncoasters.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14386602448939149210&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "castles-n-coasters",
      "poi_latitude": "33.5725174",
      "poi_longitude": "-112.1188154",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 602-997-7575",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-ae9b-7635-b1ce-5e61c8174a0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-ae9b-7635-b1ce-5e61c8174a0d",
        "storage_key": "property/6767906449167149/019d021b-ae9b-7635-b1ce-5e61c8174a0d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_____xgSK4cRmmfILbR6p8c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_6858f8cd-8592-432e-b3d3-7a5677d9cdcf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Martin Auto Museum and Event Center",
      "poi_type": "Entertainment",
      "poi_address": "4320 W Thunderbird Rd, Glendale, AZ 85306, USA",
      "poi_short_description": "Fascinating space featuring over 170 cars spanning 130 years of history such as hot rods and Shelby Cobras.",
      "poi_long_description": "People say this museum offers a vast collection of vintage and classic cars, as well as a carousel and game room. They highlight the affordable price, the opportunity to sit in many of the cars, and the clean and well-maintained facilities. They also like the friendly, knowledgeable, and welcoming staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-f6be-70c6-98cf-18bfbd7501f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-f6be-70c6-98cf-18bfbd7501f2",
        "storage_key": "property/6767906449167149/019d021b-f6be-70c6-98cf-18bfbd7501f2.webp",
        "width": 828,
        "height": 466
      },
      "poi_business_url": "https://www.martinautomuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9291038243856928640&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "martin-auto-museum-and-event-center",
      "poi_latitude": "33.6122996",
      "poi_longitude": "-112.1525224",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 602-298-2377",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-b339-7591-9254-0a01a35614af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-b339-7591-9254-0a01a35614af",
        "storage_key": "property/6767906449167149/019d021b-b339-7591-9254-0a01a35614af.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJLetTmuFuK4cRgE-phw5m8IA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_897f572c-eeac-4362-91b5-c6051b20902c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "River Ranch Water Park",
      "poi_type": "Entertainment",
      "poi_address": "7667 N 18th Pl, Phoenix, AZ 85020, USA",
      "poi_short_description": "Water park featuring a lazy river, along with mini-golf and a restaurant.",
      "poi_long_description": "Visitors say this water park has a lazy river, a waterslide, and a pool with a volleyball net and waterfall. They also highlight the availability of cabana rentals, day passes, and towels.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-fa5e-773d-ac0b-80cd19b2afcd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-fa5e-773d-ac0b-80cd19b2afcd",
        "storage_key": "property/6767906449167149/019d021b-fa5e-773d-ac0b-80cd19b2afcd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15631802649349206176&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "river-ranch-water-park",
      "poi_latitude": "33.5486089",
      "poi_longitude": "-112.0439762",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-ae9b-7635-b1ce-5e61c8174a0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-ae9b-7635-b1ce-5e61c8174a0d",
        "storage_key": "property/6767906449167149/019d021b-ae9b-7635-b1ce-5e61c8174a0d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMfYjWxBzK4cRoDB4UbBR79g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_7ff3cd68-a580-40cf-9855-ce8ab1511556",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Norman Lykes House",
      "poi_type": "Entertainment",
      "poi_address": "6836 N 36th St, Phoenix, AZ 85018, USA",
      "poi_short_description": "Circular 🏠, Frank Lloyd Wright-designed residence, featuring a crescent-shaped pool and valley views, available to rent.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-fba3-75ea-8efb-9e5607dda282.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-fba3-75ea-8efb-9e5607dda282",
        "storage_key": "property/6767906449167149/019d021b-fba3-75ea-8efb-9e5607dda282.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://normanlykes.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1662068407034571049&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "norman-lykes-house",
      "poi_latitude": "33.5387247",
      "poi_longitude": "-112.0030071",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 23 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 602-315-1426",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-ae9b-7635-b1ce-5e61c8174a0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-ae9b-7635-b1ce-5e61c8174a0d",
        "storage_key": "property/6767906449167149/019d021b-ae9b-7635-b1ce-5e61c8174a0d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmXeUpykNK4cRKemxAWnaEBc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_6b7cb880-a739-406b-9f3b-0992f92a870b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "EōS Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "12211 N Cave Creek Rd, Phoenix, AZ 85022, USA",
      "poi_short_description": "Chain gym in the Cactus Gardens neighborhood offering a variety of equipment, group fitness classes, and personal training.",
      "poi_long_description": "Visitors say this gym offers a variety of amenities, including a sauna, jacuzzi, pool, and kids' playroom, as well as 24/7 access and a wide range of workout equipment. They also highlight the friendly and helpful staff, particularly Alexia, who is often praised for her exceptional service.\n\nSome reviews mention the membership cancellation process can be difficult.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://eosfitness.com/gym/phoenix-cactus-rd-cave-creek/?utm_source=local&utm_medium=organic&utm_campaign=evergreen_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=10612127455020622242&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "es-fitness",
      "poi_latitude": "33.5978816",
      "poi_longitude": "-112.0354343",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 602-654-4430",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-ae9b-7635-b1ce-5e61c8174a0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-ae9b-7635-b1ce-5e61c8174a0d",
        "storage_key": "property/6767906449167149/019d021b-ae9b-7635-b1ce-5e61c8174a0d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK49Ey2VzK4cRoqGs47HZRZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b6deb040-81f3-4b6d-93de-7ae2348a11de",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Mountainside Fitness Paradise Valley",
      "poi_type": "Health and Wellness",
      "poi_address": "5320 E Shea Blvd, Scottsdale, AZ 85254, USA",
      "poi_short_description": "Upbeat gym offering an assortment of classes including yoga, while kids play in childcare facilities.",
      "poi_long_description": "People say this fitness center offers a wide variety of equipment, including free weights, cardio machines, and a basketball half-court, as well as amenities like a sauna, steam room, and smoothie bar. They highlight the reasonable pricing, convenient location, and ample parking. They also like the friendly and helpful staff.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://mountainsidefitness.com/locations/paradise-valley/?utm_source=GMB&utm_medium=Local&utm_campaign=ParadiseValley&utm_content=WebsiteLink",
      "poi_directions_map_url": "https://maps.google.com/?cid=4068151120091528431&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mountainside-fitness-paradise-valley",
      "poi_latitude": "33.5832277",
      "poi_longitude": "-111.9659574",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 480-306-4401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-ae9b-7635-b1ce-5e61c8174a0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-ae9b-7635-b1ce-5e61c8174a0d",
        "storage_key": "property/6767906449167149/019d021b-ae9b-7635-b1ce-5e61c8174a0d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn7UDxt5zK4cR77ypxeP5dDg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_d8a4a916-0c59-4ade-aa24-ef374f0babff",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Mountainside Fitness Desert Ridge",
      "poi_type": "Health and Wellness",
      "poi_address": "4355 E Irma Ln, Phoenix, AZ 85050, USA",
      "poi_short_description": "Gym and health centre offering classes from yoga to zumba, plus personal training.",
      "poi_long_description": "People say this fitness center offers a wide variety of equipment, classes, and amenities, including a smoothie bar, massage chairs, and childcare. They highlight the clean environment, convenient parking, and the availability of deals. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021c-0146-72ec-963d-3af8dfab327e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-0146-72ec-963d-3af8dfab327e",
        "storage_key": "property/6767906449167149/019d021c-0146-72ec-963d-3af8dfab327e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://mountainsidefitness.com/locations/desert-ridge/?utm_source=GMB&utm_medium=Local&utm_campaign=DesertRidge&utm_content=WebsiteLink",
      "poi_directions_map_url": "https://maps.google.com/?cid=17383186614653956397&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mountainside-fitness-desert-ridge",
      "poi_latitude": "33.6737893",
      "poi_longitude": "-111.9865464",
      "poi_miles_from_property": "11.5",
      "poi_walking_minutes": "4 hours 16 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 623-266-3111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-ae9b-7635-b1ce-5e61c8174a0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-ae9b-7635-b1ce-5e61c8174a0d",
        "storage_key": "property/6767906449167149/019d021b-ae9b-7635-b1ce-5e61c8174a0d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHevRj1VwK4cRLTHGPiB8PfE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_97ff342b-7fea-4b99-b1f1-6992ec5847c4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Element Nail Bar",
      "poi_type": "Health and Wellness",
      "poi_address": "6022 N 16th St, Phoenix, AZ 85016, USA",
      "poi_short_description": "Nail salon in Sunbrite Corner offering a wide range of nail services, as well as spa treatments.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021c-057b-75bf-b8a5-c7c54bdac52c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-057b-75bf-b8a5-c7c54bdac52c",
        "storage_key": "property/6767906449167149/019d021c-057b-75bf-b8a5-c7c54bdac52c.webp",
        "width": 1280,
        "height": 832
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17767652852326011484&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "element-nail-bar",
      "poi_latitude": "33.5245619",
      "poi_longitude": "-112.0478033",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 602-607-5686",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-ae9b-7635-b1ce-5e61c8174a0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-ae9b-7635-b1ce-5e61c8174a0d",
        "storage_key": "property/6767906449167149/019d021b-ae9b-7635-b1ce-5e61c8174a0d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuSItbchBK4cRXBJZ0yFik_Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_39a4a23c-f537-4ecd-8879-b03b851c202a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "VASA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3131 E Thunderbird Rd, Phoenix, AZ 85032, USA",
      "poi_short_description": "Clean gym with workout machines, free weights and group classes.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including a booty builder glute hip thrust machine, Olympic lifting stations, and functional fitness options like sandbags and kettlebells. They highlight the affordable price, the clean and well-maintained facilities, and the fun and encouraging instructors. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021c-03b4-71a7-8394-cb75c2d90c26.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-03b4-71a7-8394-cb75c2d90c26",
        "storage_key": "property/6767906449167149/019d021c-03b4-71a7-8394-cb75c2d90c26.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://vasafitness.com/locations/az/thunderbird-32nd/?utm_medium=organic&utm_source=GMBlisting&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=5496977295357890932&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vasa-fitness",
      "poi_latitude": "33.6105309",
      "poi_longitude": "-112.0146247",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 602-476-2666",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-ae9b-7635-b1ce-5e61c8174a0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-ae9b-7635-b1ce-5e61c8174a0d",
        "storage_key": "property/6767906449167149/019d021b-ae9b-7635-b1ce-5e61c8174a0d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyVnaB5BzK4cRdNEx1LkvSUw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_4c1f4a1b-2a3a-49a4-af8b-c2dc7c514317",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "HonorHealth Deer Valley Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "19829 N 27th Ave, Phoenix, AZ 85027, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-a01d-7418-b1f6-b40702e830db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-a01d-7418-b1f6-b40702e830db",
        "storage_key": "property/6767906449167149/019d021b-a01d-7418-b1f6-b40702e830db.webp",
        "width": 800,
        "height": 300
      },
      "poi_business_url": "https://www.honorhealth.com/locations/hospitals/deer-valley-medical-center?utm_source=GMB&utm_medium=local&utm_campaign=Valley_Medical_Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=15230205930965625593&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "honorhealth-deer-valley-medical-center",
      "poi_latitude": "33.6655324",
      "poi_longitude": "-112.1164943",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 623-879-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-b580-739a-a068-c0a55dbfd45c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-b580-739a-a068-c0a55dbfd45c",
        "storage_key": "property/6767906449167149/019d021b-b580-739a-a068-c0a55dbfd45c.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6fTTNBRvK4cR-epA45mPXNM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_943f3f66-a73b-48eb-8bc1-ae65b8446a20",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "HonorHealth John C. Lincoln Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "250 E Dunlap Ave, Phoenix, AZ 85020, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021c-0ad4-72f9-b3f0-450551e5d6da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-0ad4-72f9-b3f0-450551e5d6da",
        "storage_key": "property/6767906449167149/019d021c-0ad4-72f9-b3f0-450551e5d6da.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.honorhealth.com/locations/hospitals/john-c-lincoln-medical-center?utm_source=GMB&utm_medium=local&utm_campaign=John_C_Lincoln_Medical_Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=12142764189857656654&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "honorhealth-john-c-lincoln-medical-center",
      "poi_latitude": "33.5692679",
      "poi_longitude": "-112.070868",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 602-943-2381",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-b580-739a-a068-c0a55dbfd45c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-b580-739a-a068-c0a55dbfd45c",
        "storage_key": "property/6767906449167149/019d021b-b580-739a-a068-c0a55dbfd45c.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1UpS2HRtK4cRTq_MD7LDg6g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_27ce525f-71c0-4b06-b32a-d08ab70bfa6c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Piestewa Peak Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2701 Piestewa Peak Dr, Phoenix, AZ 85016, USA",
      "poi_short_description": "Trio of trails, boasting panoramic views, desert foliage, and steep rock formations for all fitness levels.",
      "poi_long_description": "People say this hiking area offers a challenging hike with stunning views of the valley and unique rock formations. They highlight the well-maintained trail, ample parking, and convenient facilities, including bathrooms and a drinking fountain. They also like the sense of community among fellow hikers and the opportunity to connect with nature. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021c-0bbf-7541-9d8f-61a357234600.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-0bbf-7541-9d8f-61a357234600",
        "storage_key": "property/6767906449167149/019d021c-0bbf-7541-9d8f-61a357234600.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.phoenix.gov/parks/trails/locations/piestewa-peak/hiking-trail-map",
      "poi_directions_map_url": "https://maps.google.com/?cid=12134414538075838070&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "piestewa-peak-trailhead",
      "poi_latitude": "33.5396234",
      "poi_longitude": "-112.0228315",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-ae9b-7635-b1ce-5e61c8174a0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-ae9b-7635-b1ce-5e61c8174a0d",
        "storage_key": "property/6767906449167149/019d021b-ae9b-7635-b1ce-5e61c8174a0d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCzyevMpyK4cRdpZYQ7sZZqg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_f020edf9-e815-4ef7-96dc-ebdea260ebe2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Roadrunner Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3502 E Cactus Rd, Phoenix, AZ 85032, USA",
      "poi_short_description": "Wide-open area that's home to games including  baseball, soccer & tennis plus a farmer's market.",
      "poi_long_description": "People say this park offers a playground, a pond with ducks and fish, sports fields, and a farmers market on Saturdays. They highlight the spaciousness, the walking paths, and the family-friendly atmosphere. They also like the clean restrooms and the recent renovations.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.phoenix.gov/parks/parks/alphabetical/r-parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=10941967353518005624&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "roadrunner-park",
      "poi_latitude": "33.5995051",
      "poi_longitude": "-112.0066504",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 602-262-6696",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-b335-7329-b48c-b43181d5ff77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-b335-7329-b48c-b43181d5ff77",
        "storage_key": "property/6767906449167149/019d021b-b335-7329-b48c-b43181d5ff77.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJqzmnvU5yK4cReJ1cwlWt2Zc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_185b8914-d538-4c86-8ad1-b42a89799d7d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Dreamy Draw Recreation Area",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2421 E Northern Ave, Phoenix, AZ 85020, USA",
      "poi_short_description": "Expansive public park with miles of hiking & biking trails winding through rocky desert terrain.",
      "poi_long_description": "Hikers say this recreation area offers a wide variety of trails for all levels, from paved paths suitable for strollers and bikes to challenging hikes with scenic views. They also highlight the clean restrooms, ample parking, and plentiful water fountains, making it a convenient and enjoyable spot for outdoor activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021c-0cbc-76c8-aaee-1ed2e0ab212e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-0cbc-76c8-aaee-1ed2e0ab212e",
        "storage_key": "property/6767906449167149/019d021c-0cbc-76c8-aaee-1ed2e0ab212e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.phoenix.gov/parks/trails/locations/piestewa-peak",
      "poi_directions_map_url": "https://maps.google.com/?cid=4114834764206794336&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dreamy-draw-recreation-area",
      "poi_latitude": "33.5642105",
      "poi_longitude": "-112.0288628",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 602-262-7901",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-ae9b-7635-b1ce-5e61c8174a0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-ae9b-7635-b1ce-5e61c8174a0d",
        "storage_key": "property/6767906449167149/019d021b-ae9b-7635-b1ce-5e61c8174a0d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_____xgSK4cRYGb5rWrUGjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_ae988250-ed5b-4445-8294-c77b50508dd9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Phoenix Mountains Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2701 Piestewa Peak Dr, Phoenix, AZ 85016, USA",
      "poi_short_description": "Group of parks with mountain & desert hiking trails, plus an abundance of cacti & native wildlife.",
      "poi_long_description": "People say this nature preserve offers a variety of trails for hiking, biking, and walking, with options for all levels of ability. They highlight the beautiful desert scenery, stunning views, and opportunities for solitude, especially on less popular trails. They also like the well-marked and maintained trails, and the availability of amenities such as restrooms and water bottle filling stations. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021c-0cf5-720a-a62f-6ff3479a27c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-0cf5-720a-a62f-6ff3479a27c9",
        "storage_key": "property/6767906449167149/019d021c-0cf5-720a-a62f-6ff3479a27c9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.phoenix.gov/parks/trails/locations/piestewa-peak",
      "poi_directions_map_url": "https://maps.google.com/?cid=768664447671239094&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "phoenix-mountains-preserve",
      "poi_latitude": "33.5620742",
      "poi_longitude": "-112.0209097",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 602-261-8318",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-b335-7329-b48c-b43181d5ff77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-b335-7329-b48c-b43181d5ff77",
        "storage_key": "property/6767906449167149/019d021b-b335-7329-b48c-b43181d5ff77.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8UYsGO1yK4cRtoHqGj7Yqgo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_7b2d8f10-b1a0-45b3-880a-8bafc884a8bb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Granada Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6505 N 20th St, Phoenix, AZ 85016, USA",
      "poi_short_description": "An ample green space with a playground, paths, picnic facilities, a multiuse field, tennis & lake.",
      "poi_long_description": "Visitors say this park offers stunning mountain views, two duck ponds, and plenty of shade trees, making it a great place for picnics, fishing, and enjoying the sunset. They also highlight the clean restrooms, well-maintained playground, and friendly atmosphere, making it a great spot for families with kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021c-11dd-720d-9d0e-755806d6fec6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-11dd-720d-9d0e-755806d6fec6",
        "storage_key": "property/6767906449167149/019d021c-11dd-720d-9d0e-755806d6fec6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.phoenix.gov/parks/parks/alphabetical/g-parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=4028341282597122180&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "granada-park",
      "poi_latitude": "33.5325717",
      "poi_longitude": "-112.0363253",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 602-262-6696",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-b335-7329-b48c-b43181d5ff77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-b335-7329-b48c-b43181d5ff77",
        "storage_key": "property/6767906449167149/019d021b-b335-7329-b48c-b43181d5ff77.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJvxfulk0NK4cRhDA-rw2L5zc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1b80f358-30b0-48a3-bc2d-b2323a838c34",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Phoenix Deer Valley Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "702 W Deer Valley Rd, Phoenix, AZ 85027, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this regional airport offers a unique experience with great views of aircraft landing and taking off. They highlight the friendly and professional staff, and the clean and relaxing atmosphere. They also like the self-serve gas and the opportunity to take flying lessons.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021c-120d-7624-b987-a6c6b604b353.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-120d-7624-b987-a6c6b604b353",
        "storage_key": "property/6767906449167149/019d021c-120d-7624-b987-a6c6b604b353.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://deervalleyairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3121833364810829412&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "phoenix-deer-valley-airport",
      "poi_latitude": "33.6854102",
      "poi_longitude": "-112.083264",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 623-869-0975",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-b709-7327-84f7-628a15c589fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-b709-7327-84f7-628a15c589fe",
        "storage_key": "property/6767906449167149/019d021b-b709-7327-84f7-628a15c589fe.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJI3ydkItvK4cRZA6Dtef6Uis",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_3c413eaf-435d-4294-b537-b076704cf33d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "19th Ave/Dunlap",
      "poi_type": "Transportation & Transit",
      "poi_address": "1901 W Dunlap Ave, Phoenix, AZ 85021, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021c-1496-73aa-bff0-ed5ec0d4b6d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-1496-73aa-bff0-ed5ec0d4b6d5",
        "storage_key": "property/6767906449167149/019d021c-1496-73aa-bff0-ed5ec0d4b6d5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.valleymetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10720189826567534372&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "19th-avedunlap",
      "poi_latitude": "33.567376",
      "poi_longitude": "-112.10084",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 602-253-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-ae9b-7635-b1ce-5e61c8174a0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-ae9b-7635-b1ce-5e61c8174a0d",
        "storage_key": "property/6767906449167149/019d021b-ae9b-7635-b1ce-5e61c8174a0d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoYFO8lVsK4cRJHdQadnDxZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_36c30a19-a5e8-4819-a2f7-7d138fe10297",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Metro Pkwy",
      "poi_type": "Transportation & Transit",
      "poi_address": "Phoenix, AZ 85051, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021c-148b-734b-a60d-5f829a5c1f31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-148b-734b-a60d-5f829a5c1f31",
        "storage_key": "property/6767906449167149/019d021c-148b-734b-a60d-5f829a5c1f31.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3095258421458371006&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "metro-pkwy",
      "poi_latitude": "33.575092",
      "poi_longitude": "-112.118469",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-ae9b-7635-b1ce-5e61c8174a0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-ae9b-7635-b1ce-5e61c8174a0d",
        "storage_key": "property/6767906449167149/019d021b-ae9b-7635-b1ce-5e61c8174a0d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh7kvo0JsK4cRvgEQiyKR9Co",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_2a90771b-d3a2-4150-9966-cb92d68f7d62",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Cutter Aviation Phoenix Deer Valley (DVT)",
      "poi_type": "Transportation & Transit",
      "poi_address": "732 W Deer Valley Rd, Phoenix, AZ 85027, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021c-1789-75ff-90db-924bc9cc0821.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-1789-75ff-90db-924bc9cc0821",
        "storage_key": "property/6767906449167149/019d021c-1789-75ff-90db-924bc9cc0821.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://cutteraviation.com/dvt",
      "poi_directions_map_url": "https://maps.google.com/?cid=16042462963326340164&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cutter-aviation-phoenix-deer-valley-dvt",
      "poi_latitude": "33.6851344",
      "poi_longitude": "-112.0839509",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 623-581-1444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-b709-7327-84f7-628a15c589fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-b709-7327-84f7-628a15c589fe",
        "storage_key": "property/6767906449167149/019d021b-b709-7327-84f7-628a15c589fe.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJKTdIb5BvK4cRRExtixFHot4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_eaf9b151-7486-4088-b363-29b706c4cfc9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Glendale/19th Ave",
      "poi_type": "Transportation & Transit",
      "poi_address": "Phoenix, AZ 85021, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021c-18b0-71dd-86d1-c4cfdde19bc6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-18b0-71dd-86d1-c4cfdde19bc6",
        "storage_key": "property/6767906449167149/019d021c-18b0-71dd-86d1-c4cfdde19bc6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17712783669072054624&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "glendale19th-ave",
      "poi_latitude": "33.537456",
      "poi_longitude": "-112.099688",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-ae9b-7635-b1ce-5e61c8174a0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-ae9b-7635-b1ce-5e61c8174a0d",
        "storage_key": "property/6767906449167149/019d021b-ae9b-7635-b1ce-5e61c8174a0d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK_VaEtlsK4cRYElhkuZy0PU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_6b79bb18-073b-4b16-93b2-f2d38c6b38e6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "PetSmart Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "19601 N 27th Ave, Phoenix, AZ 85027, USA",
      "poi_short_description": "Chain featuring a range of pets, supplies & food (most offer grooming, boarding & other services).",
      "poi_long_description": "Chain featuring a range of pets, supplies & food (most offer grooming, boarding & other services).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-9a81-71ef-ba97-9cc08ca3bff2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-9a81-71ef-ba97-9cc08ca3bff2",
        "storage_key": "property/6767906449167149/019d021b-9a81-71ef-ba97-9cc08ca3bff2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://pets.petsmart.com/help/contact-us/contact-corporate.shtml",
      "poi_directions_map_url": "https://maps.google.com/?cid=11160285302803478114&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "petsmart-corporate-office",
      "poi_latitude": "33.663657",
      "poi_longitude": "-112.1159034",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 888-839-9638",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-ae9b-7635-b1ce-5e61c8174a0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-ae9b-7635-b1ce-5e61c8174a0d",
        "storage_key": "property/6767906449167149/019d021b-ae9b-7635-b1ce-5e61c8174a0d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMaK89BZvK4cRYjadaVpM4Zo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_e5d9017f-f920-4b95-a076-01e0f1f05dcc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Honeywell Aerospace Technologies - Deer Valley",
      "poi_type": "Major Employers & Offices",
      "poi_address": "21111 N 19th Ave, Phoenix, AZ 85027, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021c-1c9d-74b7-bc59-4c2ae6ad24a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-1c9d-74b7-bc59-4c2ae6ad24a2",
        "storage_key": "property/6767906449167149/019d021c-1c9d-74b7-bc59-4c2ae6ad24a2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=404546493164785334&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "honeywell-aerospace-technologies---deer-valley",
      "poi_latitude": "33.6795907",
      "poi_longitude": "-112.09847",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-ae9b-7635-b1ce-5e61c8174a0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-ae9b-7635-b1ce-5e61c8174a0d",
        "storage_key": "property/6767906449167149/019d021b-ae9b-7635-b1ce-5e61c8174a0d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR2rtYXZvK4cRto43ZOQ8nQU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_6d911da6-8b68-424a-9a49-bcdbdd8e8752",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Charles Schwab Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2423 E Lincoln Dr, Phoenix, AZ 85016, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.schwab.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9818663216570429998&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "charles-schwab-corporate-office",
      "poi_latitude": "33.5302477",
      "poi_longitude": "-112.0291931",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 800-435-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-ae9b-7635-b1ce-5e61c8174a0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-ae9b-7635-b1ce-5e61c8174a0d",
        "storage_key": "property/6767906449167149/019d021b-ae9b-7635-b1ce-5e61c8174a0d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAVXVCUwNK4cRLvLfiCzmQog",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_0c3a3a3f-e602-4a6d-99e9-3d7dca4fdbc0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Maricopa Ambulance",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10243 N 19th Ave B, Phoenix, AZ 85021, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021c-1f30-7758-89c2-d5fe55f17a8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-1f30-7758-89c2-d5fe55f17a8e",
        "storage_key": "property/6767906449167149/019d021c-1f30-7758-89c2-d5fe55f17a8e.webp",
        "width": 1280,
        "height": 725
      },
      "poi_business_url": "https://www.maricopaambulance.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12641644849842697492&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "maricopa-ambulance",
      "poi_latitude": "33.579714",
      "poi_longitude": "-112.09836",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 480-485-2900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-ae9b-7635-b1ce-5e61c8174a0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-ae9b-7635-b1ce-5e61c8174a0d",
        "storage_key": "property/6767906449167149/019d021b-ae9b-7635-b1ce-5e61c8174a0d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd9rip01sK4cRFDWFOwMlcK8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_4bdd5bf2-c1a3-41a0-ab48-3071048e3116",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Cox Business Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1550 W Deer Valley Rd, Phoenix, AZ 85027, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021c-1df3-7124-bcac-6b3e42e3f3fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-1df3-7124-bcac-6b3e42e3f3fc",
        "storage_key": "property/6767906449167149/019d021c-1df3-7124-bcac-6b3e42e3f3fc.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.cox.com/business/internet/business-internet.html?sc_id=cblcl_cbsem_cbint_cp-p-i-ipzz-25tz_gmb_cbgoog",
      "poi_directions_map_url": "https://maps.google.com/?cid=16713051001169255921&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cox-business-corporate-office",
      "poi_latitude": "33.6842677",
      "poi_longitude": "-112.0948226",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 888-751-9138",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-ae9b-7635-b1ce-5e61c8174a0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-ae9b-7635-b1ce-5e61c8174a0d",
        "storage_key": "property/6767906449167149/019d021b-ae9b-7635-b1ce-5e61c8174a0d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjWmE_ndvK4cR8R2uBVav8Oc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_22f9a76f-b171-4372-8652-1c630e5de04c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Chili's Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "10237 N Metro Pkwy W, Phoenix, AZ 85051, USA",
      "poi_short_description": "Family-friendly chain serving classic Tex-Mex & American fare in a Southwestern-style setting.",
      "poi_long_description": "Diners like this restaurant's delicious burgers, fajitas, and the \"3 For Me\" meal deal, which offers great value. They also highlight the friendly and attentive staff, as well as the clean dining area.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019fc9e4-5042-718b-80eb-80a2017c0c6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc9e4-5042-718b-80eb-80a2017c0c6e",
        "storage_key": "property/6767906449167149/019fc9e4-5042-718b-80eb-80a2017c0c6e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.chilis.com/locations/us/arizona/phoenix/metro-center?utm_source=google&utm_medium=local&utm_campaign=Chilis",
      "poi_directions_map_url": "https://maps.google.com/?cid=12555089569321984223&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chilis-grill--bar",
      "poi_latitude": "33.579858",
      "poi_longitude": "-112.12211599999999",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "73",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 602-997-4600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-a801-762c-a57d-12f2948e40f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-a801-762c-a57d-12f2948e40f4",
        "storage_key": "property/6767906449167149/019d021b-a801-762c-a57d-12f2948e40f4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJP6U4wGtsK4cR3yCmjnGjPK4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_6a1e05e0-3d75-4a98-8944-1cf5c1c537eb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "16806 N 7th St, Phoenix, AZ 85022, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Customers consistently praise this store for being clean, well-stocked, and organized, offering a good selection of basic grocery items and merchandise at great prices. Reviewers also highlight the friendly and knowledgeable staff, along with the spotless restrooms.\n\nSome reviews mention the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019fc9e4-4eaa-778d-99cd-2d280db5ea0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc9e4-4eaa-778d-99cd-2d280db5ea0a",
        "storage_key": "property/6767906449167149/019fc9e4-4eaa-778d-99cd-2d280db5ea0a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/phoenix-7th-street-and-bell/2236",
      "poi_directions_map_url": "https://maps.google.com/?cid=12458947798767222555&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "33.638108599999995",
      "poi_longitude": "-112.0688753",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "75",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 602-794-3601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-ac98-7579-a2cb-5f6e90fd0f65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-ac98-7579-a2cb-5f6e90fd0f65",
        "storage_key": "property/6767906449167149/019d021b-ac98-7579-a2cb-5f6e90fd0f65.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJF3ZAdz5uK4cRG7-nPAMT56w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_db1fb415-2862-4831-a7b5-351d8e3a36a9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Fry's",
      "poi_type": "Shopping & Retail",
      "poi_address": "4025 E Thunderbird Rd, Phoenix, AZ 85032, USA",
      "poi_short_description": "Outpost of a grocery store chain with typical offerings like produce, meat & household supplies.",
      "poi_long_description": "People say this grocery store offers a good variety of fresh produce, meat, and other groceries, with many highlighting the delicious fried chicken from the deli. They also mention the clean and well-organized store, friendly and helpful staff, and competitive prices.\n\nSome reviews mention the service can be unprofessional.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/01a0b082-d039-740b-91e8-4ef0cb79c21a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b082-d039-740b-91e8-4ef0cb79c21a",
        "storage_key": "property/6767906449167149/01a0b082-d039-740b-91e8-4ef0cb79c21a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.frysfood.com/stores/grocery/az/phoenix/40th-st-thunderbird/660/00121?cid=loc_66000121_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=3658592837888486881&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "frys",
      "poi_latitude": "33.610996",
      "poi_longitude": "-111.994189",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "87",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 602-953-1615",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-ae90-76b9-aa55-ad18cc6a102b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-ae90-76b9-aa55-ad18cc6a102b",
        "storage_key": "property/6767906449167149/019d021b-ae90-76b9-aa55-ad18cc6a102b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN6I46MtzK4cR4a0hUM3uxTI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_d2295bcd-a8ea-45f7-b407-a0a59caf9da2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "1050 E Bell Rd, Phoenix, AZ 85022, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "Reviewers consistently praise this restaurant for its delicious and tender chicken fingers, flavorful Cane's sauce, crispy fries, and good Texas toast. Customers also highlight the friendly and attentive staff.\n\nSome reviews mention that orders can be incorrect.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/01a0b082-d0f7-7698-961a-4c6625b55014.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b082-d0f7-7698-961a-4c6625b55014",
        "storage_key": "property/6767906449167149/01a0b082-d0f7-7698-961a-4c6625b55014.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://locations.raisingcanes.com/az/phoenix/1050-east-bell-road",
      "poi_directions_map_url": "https://maps.google.com/?cid=15708382717083167900&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "33.6408964",
      "poi_longitude": "-112.0592496",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "82",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 602-595-4984",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-a801-762c-a57d-12f2948e40f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-a801-762c-a57d-12f2948e40f4",
        "storage_key": "property/6767906449167149/019d021b-a801-762c-a57d-12f2948e40f4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJrZfn1SJuK4cRnKygx9pi_9k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_7dd20215-abe8-4668-ab5b-56ab60c51d28",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Dave's Hot Chicken",
      "poi_type": "Restaurants",
      "poi_address": "475 E Bell Rd, Phoenix, AZ 85022, USA",
      "poi_short_description": "Casual restaurant turning out sandwiches and burgers with varying levels of spice, plus mac 'n' cheese and fries.",
      "poi_long_description": "People say this restaurant offers delicious, juicy, and flavorful hot chicken, with a variety of spice levels and generous portions. They also highlight the fast and friendly service, with staff often described as welcoming and helpful. Visitors appreciate the clean environment and the overall positive atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/01a0b082-d10a-746f-af2d-5d9e807cbb3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b082-d10a-746f-af2d-5d9e807cbb3a",
        "storage_key": "property/6767906449167149/01a0b082-d10a-746f-af2d-5d9e807cbb3a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://restaurants.daveshotchicken.com/az/phoenix/475-east-bell-rd.-1177?utm_campaign=google_maps&utm_medium=organic&utm_source=google&utm_content=website&utm_term=1177",
      "poi_directions_map_url": "https://maps.google.com/?cid=2720842623103870139&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "daves-hot-chicken",
      "poi_latitude": "33.6399457",
      "poi_longitude": "-112.0669638",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "75",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 480-864-9899",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-a801-762c-a57d-12f2948e40f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-a801-762c-a57d-12f2948e40f4",
        "storage_key": "property/6767906449167149/019d021b-a801-762c-a57d-12f2948e40f4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEbUecIxvK4cRuyTZN_NfwiU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_restaurant"
    },
    {
      "id": "custom_e2c01eba-0360-4e95-a56b-55a2de1bd8ad",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Yutaka Japanese Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "751 E Bell Rd #9, Phoenix, AZ 85022, USA",
      "poi_short_description": "Intimate Japanese restaurant with minimalist décor & sushi, sashimi & teriyaki on the long menu.",
      "poi_long_description": "Diners like this restaurant's delicious and authentic ramen, sushi, and appetizers, noting the generous portion sizes. They also highlight the reasonable prices and the friendly, attentive, and efficient service. Guests mention the cozy, intimate atmosphere, despite the small dining area, and appreciate the convenient takeout option.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/01a0b082-cb7e-7477-8d59-75a93c401fb1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b082-cb7e-7477-8d59-75a93c401fb1",
        "storage_key": "property/6767906449167149/01a0b082-cb7e-7477-8d59-75a93c401fb1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sites.google.com/view/yutakarestaurant/home",
      "poi_directions_map_url": "https://maps.google.com/?cid=15462936645699454162&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "yutaka-japanese-restaurant",
      "poi_latitude": "33.6392327",
      "poi_longitude": "-112.0632425",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "74",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 602-843-8882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-a801-762c-a57d-12f2948e40f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-a801-762c-a57d-12f2948e40f4",
        "storage_key": "property/6767906449167149/019d021b-a801-762c-a57d-12f2948e40f4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJa2jNMzxuK4cR0kRJ__Nil9Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_a93201eb-9510-49f9-bdde-46b2ce98f19c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Chipotle Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "425 E Bell Rd, Phoenix, AZ 85022, USA",
      "poi_short_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_long_description": "People say this restaurant offers fresh and delicious food, including tasty guacamole, with quick service and a clean atmosphere provided by helpful and friendly staff.\n\nOther reviews mention portions can be small and service can be unprofessional.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/01a0b082-cff7-743b-b8bf-9b01767c06c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b082-cff7-743b-b8bf-9b01767c06c3",
        "storage_key": "property/6767906449167149/01a0b082-cff7-743b-b8bf-9b01767c06c3.webp",
        "width": 1280,
        "height": 797
      },
      "poi_business_url": "https://locations.chipotle.com/az/phoenix/425-e-bell-rd?utm_source=google&utm_medium=yext&utm_campaign=yext_listings?restaurant=1450",
      "poi_directions_map_url": "https://maps.google.com/?cid=15285517258359051361&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chipotle-mexican-grill",
      "poi_latitude": "33.6399341",
      "poi_longitude": "-112.0674683",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "75",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 602-441-0740",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-a801-762c-a57d-12f2948e40f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-a801-762c-a57d-12f2948e40f4",
        "storage_key": "property/6767906449167149/019d021b-a801-762c-a57d-12f2948e40f4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHziHh0RuK4cRYRSY2PUQIdQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_afce1538-d356-4988-9a5c-7ab61c9a25ac",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Five Guys",
      "poi_type": "Restaurants",
      "poi_address": "425 E Bell Rd Ste 130, Phoenix, AZ 85022, USA",
      "poi_short_description": "Fast-food chain with made-to-order burgers, fries & hot dogs, plus free peanuts while you wait.",
      "poi_long_description": "People say this burger joint offers delicious, customizable burgers and generous portions of crispy fries, along with thick and tasty shakes. They also highlight the complimentary peanuts, the clean establishment, and the friendly, professional staff.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/01a0b082-ca69-73d1-99c9-15e02179ea64.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b082-ca69-73d1-99c9-15e02179ea64",
        "storage_key": "property/6767906449167149/01a0b082-ca69-73d1-99c9-15e02179ea64.webp",
        "width": 1280,
        "height": 1087
      },
      "poi_business_url": "https://restaurants.fiveguys.com/425-east-bell-road",
      "poi_directions_map_url": "https://maps.google.com/?cid=5176507346217561848&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "five-guys",
      "poi_latitude": "33.6399433",
      "poi_longitude": "-112.067633",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "75",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 602-334-1209",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-a801-762c-a57d-12f2948e40f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-a801-762c-a57d-12f2948e40f4",
        "storage_key": "property/6767906449167149/019d021b-a801-762c-a57d-12f2948e40f4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7-b_7j5uK4cR-G5_TAGm1kc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_147a2d96-438e-4bdb-9ee0-bc5066cf31cb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Panera Bread",
      "poi_type": "Restaurants",
      "poi_address": "375 E Bell Rd Pad D, Phoenix, AZ 85022, USA",
      "poi_short_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_long_description": "People say this cafe offers delicious and healthy food choices like broccoli cheddar soup and fresh salads, along with friendly and efficient service.\n\nOther reviews mention orders can be incomplete or incorrect.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/01a0b082-cb29-76a4-bde4-13b4623e5787.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b082-cb29-76a4-bde4-13b4623e5787",
        "storage_key": "property/6767906449167149/01a0b082-cb29-76a4-bde4-13b4623e5787.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.panerabread.com/en-us/cafe/locations/az/phoenix/375-e-bell-road?utm_medium=local&utm_source=google&utm_campaign=dpm-dist&utm_term=601925&utm_content=main",
      "poi_directions_map_url": "https://maps.google.com/?cid=7936154664590087246&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "panera-bread",
      "poi_latitude": "33.639934",
      "poi_longitude": "-112.068172",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "76",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 602-296-5151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-a800-71f1-9043-c968ee532761.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-a800-71f1-9043-c968ee532761",
        "storage_key": "property/6767906449167149/019d021b-a800-71f1-9043-c968ee532761.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ-3CP5T5uK4cRTpRzsZ7iIm4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_e3e61a31-b3ea-4f11-945d-7f1ad6d49035",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Einstein Bros. Bagels",
      "poi_type": "Restaurants",
      "poi_address": "4030 E Thunderbird Rd, Phoenix, AZ 85032, USA",
      "poi_short_description": "Neighborhood chain bakery offering freshly baked bagels, breakfast sandwiches, and coffees.",
      "poi_long_description": "Customers consistently praise this bagel shop for its delicious bagels, breakfast sandwiches, and muffins, all made with fresh ingredients. They also appreciate the fast, friendly service and the consistently clean environment, including the restrooms.\n\nSome reviews mention the service can be inefficient.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/01a0b082-d3d0-71c1-8547-de4f045b99b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b082-d3d0-71c1-8547-de4f045b99b9",
        "storage_key": "property/6767906449167149/01a0b082-d3d0-71c1-8547-de4f045b99b9.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://locations.einsteinbros.com/us/az/phoenix/4030-e-thunderbird-rd?y_source=1_OTA0OTkwNS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=4529066125831255256&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "einstein-bros-bagels",
      "poi_latitude": "33.6123186",
      "poi_longitude": "-111.9941998",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "88",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 602-788-8301",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-a801-762c-a57d-12f2948e40f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-a801-762c-a57d-12f2948e40f4",
        "storage_key": "property/6767906449167149/019d021b-a801-762c-a57d-12f2948e40f4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJo_2T4stzK4cR2DRtOqV52j4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bagel_shop"
    },
    {
      "id": "custom_91b93678-4636-4b81-91cc-8ca63f724449",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Panda Express",
      "poi_type": "Restaurants",
      "poi_address": "3923 E Thunderbird Rd #111, Phoenix, AZ 85032, USA",
      "poi_short_description": "Fast-food chain for Chinese standards, including some health-conscious options.",
      "poi_long_description": "People say this Chinese restaurant serves delicious fried rice.\n\nOther reviews mention the orange chicken can be unavailable and the food can be stale.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/01a0b082-d307-744a-8e4c-d02e3822fa62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b082-d307-744a-8e4c-d02e3822fa62",
        "storage_key": "property/6767906449167149/01a0b082-d307-744a-8e4c-d02e3822fa62.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.pandaexpress.com/locations/az/phoenix/509?utm_source=google_gbp&utm_medium=organic&utm_campaign=websitelink",
      "poi_directions_map_url": "https://maps.google.com/?cid=8415810718370734345&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "panda-express",
      "poi_latitude": "33.6109833",
      "poi_longitude": "-111.9963784",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "86",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 602-923-9901",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-a801-762c-a57d-12f2948e40f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-a801-762c-a57d-12f2948e40f4",
        "storage_key": "property/6767906449167149/019d021b-a801-762c-a57d-12f2948e40f4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJe4EHm8tzK4cRCaFpbUL3ynQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_be9f49f2-c706-4b93-843f-c94a0e37d4a0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Yoshi's Fresh Asian Grill",
      "poi_type": "Restaurants",
      "poi_address": "12202 N Cave Creek Rd, Phoenix, AZ 85022, USA",
      "poi_short_description": "Relaxed outpost offering familiar Japanese favorites, including sushi, teriyaki & noodles.",
      "poi_long_description": "Diners like this restaurant's teriyaki chicken, katsu curry, and noodle soup, noting the food is fresh and fast. They also highlight the fair prices, especially during happy hour, and the friendly staff.\n\nSome reviews mention the dishes can be poorly prepared.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/01a0b082-ca43-7488-8c70-a99e292f3695.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b082-ca43-7488-8c70-a99e292f3695",
        "storage_key": "property/6767906449167149/01a0b082-ca43-7488-8c70-a99e292f3695.webp",
        "width": 1280,
        "height": 837
      },
      "poi_business_url": "https://yoshisfreshasiangrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13526957875142607805&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "yoshis-fresh-asian-grill",
      "poi_latitude": "33.5971784",
      "poi_longitude": "-112.0380891",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "16",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 602-485-4236",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-a801-762c-a57d-12f2948e40f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-a801-762c-a57d-12f2948e40f4",
        "storage_key": "property/6767906449167149/019d021b-a801-762c-a57d-12f2948e40f4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKSWEqANzK4cRvUOMv4Roubs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_ef6f816d-f33b-48e8-b3b9-5abf477d6f8d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Filiberto's Mexican Food",
      "poi_type": "Restaurants",
      "poi_address": "2010 E Thunderbird Rd, Phoenix, AZ 85022, USA",
      "poi_short_description": "Mexican fast-food chain outlet specializing in tacos, burritos, tostadas & quesadillas.",
      "poi_long_description": "Mexican fast-food chain outlet specializing in tacos, burritos, tostadas & quesadillas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/01a0b082-d928-7053-8905-83ff9db5365d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b082-d928-7053-8905-83ff9db5365d",
        "storage_key": "property/6767906449167149/01a0b082-d928-7053-8905-83ff9db5365d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://filibertos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6187996782178433937&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "filibertos-mexican-food",
      "poi_latitude": "33.5973061",
      "poi_longitude": "-112.0387408",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "21",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 602-404-5559",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-a801-762c-a57d-12f2948e40f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-a801-762c-a57d-12f2948e40f4",
        "storage_key": "property/6767906449167149/019d021b-a801-762c-a57d-12f2948e40f4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9xgAA3NyK4cRkXsBuUku4FU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_fe2eb946-d6b0-4995-a3bf-e7889b8086e8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Subway",
      "poi_type": "Restaurants",
      "poi_address": "3131 E Thunderbird Rd Ste 10, Phoenix, AZ 85032, USA",
      "poi_short_description": "Casual counter-serve chain for build-your-own sandwiches & salads, with health-conscious options.",
      "poi_long_description": "People say this restaurant offers excellent, fresh, and well-made subs. They also highlight the friendly, kind, and helpful staff, as well as the clean environment.\n\nSome reviews mention the service can be unprofessional.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/01a0b082-d901-734f-9218-b1e55dd4b47e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b082-d901-734f-9218-b1e55dd4b47e",
        "storage_key": "property/6767906449167149/01a0b082-d901-734f-9218-b1e55dd4b47e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://restaurants.subway.com/united-states/az/phoenix/3131-east-thunderbird-road?utm_source=yxt-goog&utm_medium=local&utm_term=acq&utm_content=28564&utm_campaign=evergreen-2020&y_source=1_MTQ5MDY3OTctNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5882855919751918363&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "subway",
      "poi_latitude": "33.6112006",
      "poi_longitude": "-112.014717",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "66",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 602-867-3460",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-a801-762c-a57d-12f2948e40f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-a801-762c-a57d-12f2948e40f4",
        "storage_key": "property/6767906449167149/019d021b-a801-762c-a57d-12f2948e40f4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJp9jChodxK4cRG_OdUUoapFE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "custom_2511d24e-9439-46f6-852d-7913411e2edf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Carolina's Mexican Food - Cactus",
      "poi_type": "Restaurants",
      "poi_address": "2126 E Cactus Rd #100, Phoenix, AZ 85022, USA",
      "poi_short_description": "Counter-serve Mexican joint serving tortillas, tacos & tamales in an unpretentious setting.",
      "poi_long_description": "Diners like this restaurant's delicious Mexican food, especially the burritos, tacos, and tamales, and highlight the fresh, huge, and tender tortillas. They also mention the reasonable prices, friendly and helpful staff, and fast service.\n\nSome reviews mention that orders can be incomplete.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/01a0b082-d736-72bc-97d6-05ba9fc8b04d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b082-d736-72bc-97d6-05ba9fc8b04d",
        "storage_key": "property/6767906449167149/01a0b082-d736-72bc-97d6-05ba9fc8b04d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.carolinasmexicanfood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4919333865410619807&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "carolinas-mexican-food---cactus",
      "poi_latitude": "33.5972014",
      "poi_longitude": "-112.0362108",
      "poi_miles_from_property": ".8",
      "poi_walking_minutes": "19",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 602-275-8231",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-a801-762c-a57d-12f2948e40f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-a801-762c-a57d-12f2948e40f4",
        "storage_key": "property/6767906449167149/019d021b-a801-762c-a57d-12f2948e40f4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJI4xNeXJyK4cRn2lZOxb8REQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_7ca33ecd-025a-4bf4-82ae-f6bfc0455adf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "North Mountain Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10608 N 7th St, Phoenix, AZ 85020, USA",
      "poi_short_description": "Hiking trails of varying difficulty lead to 2 summits for scenic views, plus a visitor center.",
      "poi_long_description": "Visitors say this park offers beautiful views and well-maintained hiking trails suitable for all levels, including a paved, wheelchair-accessible path. They also highlight the covered picnic areas, clean restrooms, and a ranger station near the entrance. Guests mention the free and ample parking, making it convenient for a quick workout or family outing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-889a-773c-91f1-628b8b5e9552.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-889a-773c-91f1-628b8b5e9552",
        "storage_key": "property/6767906449167149/019d021b-889a-773c-91f1-628b8b5e9552.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.phoenix.gov/parkssite/Pages/North-Mountain-Shaw-Butte-Trails.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=7071528748687554906&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "north-mountain-park",
      "poi_latitude": "33.5852154",
      "poi_longitude": "-112.0709411",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "64",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 602-262-7901",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-b335-7329-b48c-b43181d5ff77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-b335-7329-b48c-b43181d5ff77",
        "storage_key": "property/6767906449167149/019d021b-b335-7329-b48c-b43181d5ff77.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJM7fi5ZdtK4cRWvl7LO4dI2I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8a16951d-2c89-400e-95d3-9ac7890a3bcb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Lookout Mountain Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "14441 N 18th St, Phoenix, AZ 85022, USA",
      "poi_short_description": "Family-friendly destination with mountain views featuring volleyball and tennis courts.",
      "poi_long_description": "Visitors say this park offers rewarding hiking trails for all levels, featuring panoramic city views and rugged desert terrain. They also highlight the clean and peaceful surroundings, along with amenities like playgrounds, tennis courts, and exercise equipment. Guests mention the convenient and ample parking, as well as well-maintained restrooms and picnic areas with grills.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/01a0b082-d9ad-733d-8866-3efcdf96d6bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b082-d9ad-733d-8866-3efcdf96d6bc",
        "storage_key": "property/6767906449167149/01a0b082-d9ad-733d-8866-3efcdf96d6bc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.phoenix.gov/parks/parks/alphabetical/l-parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=4731321208802698343&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lookout-mountain-park",
      "poi_latitude": "33.6173651",
      "poi_longitude": "-112.0435184",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 602-262-6696",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-b335-7329-b48c-b43181d5ff77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-b335-7329-b48c-b43181d5ff77",
        "storage_key": "property/6767906449167149/019d021b-b335-7329-b48c-b43181d5ff77.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7XPBIAJyK4cRZ-T0YJIHqUE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_75915df8-de3f-4f0c-abf2-cc6755b97c37",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "custom",
      "poi_name": "Piestewa Peak Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2701 Piestewa Peak Dr, Phoenix, AZ 85016, USA",
      "poi_short_description": "Park with miles of trails & a scenic 2,608-foot summit which is a popular destination for hikers.",
      "poi_long_description": "Visitors say this hiking destination offers stunning views and a variety of well-maintained trails, ranging from easy to challenging. They also highlight the clean and decent restrooms, which are a welcome amenity. Guests mention the ample parking, though it can get busy, especially on weekends and at sunrise.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/01a0b082-da13-746b-8380-21deafb81623.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b082-da13-746b-8380-21deafb81623",
        "storage_key": "property/6767906449167149/01a0b082-da13-746b-8380-21deafb81623.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.phoenix.gov/parks/trails/locations/piestewa-peak",
      "poi_directions_map_url": "https://maps.google.com/?cid=4692605992828950655&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "piestewa-peak-park",
      "poi_latitude": "33.5419011",
      "poi_longitude": "-112.0170468",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "155",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 602-261-8318",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019d021b-b335-7329-b48c-b43181d5ff77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-b335-7329-b48c-b43181d5ff77",
        "storage_key": "property/6767906449167149/019d021b-b335-7329-b48c-b43181d5ff77.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVTKhuslyK4cRf1hwuUl8H0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    }
  ],
  "office_hours": [
    {
      "id": "ec_62ed14866ce4f7adc8b00404",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_b8e0ae019444e94ac29da34e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_c27f81e4d1cc9658dcd8a5df",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_970fb9304719af14f39869d0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_f332d26f858689bda11eef44",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_cef037858fe3ed82b4b5252f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_3d3e0efe-c870-4eb0-8d80-f81d7df5ad1f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "rating": "5.0",
      "name": "Delana Valtierra",
      "text": "The views are beautiful. Plenty of wildlife,  hiking trails and quiet. A hidden oasis.",
      "date": "2026-02-07",
      "title": ""
    },
    {
      "id": "custom_9d6ac1a1-3c18-40e4-9105-8c58b69f2f88",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "rating": "5.0",
      "name": "Leo F",
      "text": "We have lived here for a few weeks we have had minor issues such as dryer missing a knob etc… I will say the maintenance team is amazing! They are on top of their A-game. I have put in requests and they arrive at my door ready to work within the hour. The front desk people are amazing to! they helped me and my fiance transition smooth and welcomed us with open arms. If you are looking for a close knit community with staff that care for its residents this is the place. it’s also affordable and the views make it worth it!",
      "date": "2025-12-23",
      "title": ""
    },
    {
      "id": "custom_7e3bf5e5-a16b-45a2-975a-24a531e175fe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "rating": "5.0",
      "name": "Kari Espinoza",
      "text": "Jade was amazing  and super helpful she answered all my questions and was able to accommodate me even when I came to tour for a 2nd time without an appointment. Recently moved it in a 1 bed 1 bath and so far is great! Also the views are amazing! 🤩 Move in Day was so easy and fast thanks to Ana.",
      "date": "2026-01-30",
      "title": ""
    },
    {
      "id": "custom_b6779534-ed59-4d31-bb85-67d565fda7a9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "rating": "5.0",
      "name": "Trisha W",
      "text": "I love love love living here at the Mirador, the office and all of the maintenance staff are amazing. Just resigned my lease here and I am very happy. The area is beautiful, my dog and I love being by the golf course. The property is very dog friendly but some of the neighbors don't pick up after their dogs despite the numerous dog waste stations that are always equipped with bags. So, if you're a neighbor that doesn't pick up after their dog- do better!!",
      "date": "2025-10-27",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_d9dc0e4c2b916a517049c219",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019ddcfc-1205-7607-bff0-4c282900f5d0.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcfc-1205-7607-bff0-4c282900f5d0",
        "storage_key": "property/6767906449167149/019ddcfc-1205-7607-bff0-4c282900f5d0.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "A1",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=aNah9XFVPFR"
    },
    {
      "id": "ec_da856a6f847e2b730a8d63f1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019ddcfc-122c-73db-a660-5ceb07cb1042.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcfc-122c-73db-a660-5ceb07cb1042",
        "storage_key": "property/6767906449167149/019ddcfc-122c-73db-a660-5ceb07cb1042.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "B2",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=SsTn8bw6URs"
    },
    {
      "id": "ec_6b68127c8c225c780f7ca0a7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167149/019ddcfc-1343-742a-ba2e-6323a53a9407.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcfc-1343-742a-ba2e-6323a53a9407",
        "storage_key": "property/6767906449167149/019ddcfc-1343-742a-ba2e-6323a53a9407.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "C1",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=i7qTax8bdaT"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019eb963-4736-741d-a777-a7a88fcf6d96",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Mirador Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "generator",
      "page_item_url": "apartments-with-pool-phoenix",
      "search_query": "apartments with pool in Phoenix",
      "category": "Amenity",
      "h1_title": "Mirador Apartments with Pool in Phoenix",
      "h2_subtitle": "Looking for apartments with a pool in Phoenix? Discover Mirador, featuring refreshing amenities and a vibrant community atmosphere.",
      "page_copy": "Nestled in the scenic Pointe Golf Club On Lookout Mountain neighborhood, Mirador offers an ideal living experience in Phoenix. Our spacious apartments come equipped with a full-size washer/dryer, ceiling fans, and a private patio/balcony, ensuring every moment at home feels comfortable and luxurious. Plus, residents can enjoy 1 month of free high-speed internet courtesy of Cox Communications, making life that much more convenient.\n\nOne of the standout features of Mirador is definitely our sparkling pool, perfect for relaxation and socializing. Take a dip in the refreshing waters or lounge poolside under the Arizona sun. Located in Maricopa County, Mirador is more than just an apartment complex; it’s a community. With Cox Quick Connect services available, staying connected has never been easier. Experience the best of Phoenix living at Mirador Apartments.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Mirador: Apartments with Pool in Phoenix",
      "seo_description": "Discover Mirador Apartments in Phoenix featuring a sparkling pool, luxurious amenities, and a welcoming community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "generator",
      "page_item_url": "high-speed-internet-apartments-maricopa-county",
      "search_query": "high-speed internet apartments Maricopa County",
      "category": "Amenity",
      "h1_title": "High-Speed Internet Apartments in Maricopa County",
      "h2_subtitle": "Explore premium high-speed internet apartments in Maricopa County. Mirador offers seamless connectivity and modern living.",
      "page_copy": "At Mirador, nestled in the heart of Maricopa County, you can enjoy the modern convenience of living in a high-speed internet apartment. Our residents receive 1 month of free high-speed internet courtesy of Cox Communications, making it easy to work from home, stream, or game without interruptions. Located in the vibrant Pointe Golf Club On Lookout Mountain neighborhood, Mirador provides an ideal blend of connectivity and comfort.\n\nBeyond superior internet services, Mirador offers well-appointed homes with features like full-size washer/dryers and private patios/balconies. Ceiling fans in select living rooms and Cox Quick Connect services further enhance your living experience. Enjoy peaceful surroundings in Phoenix and stay effortlessly connected at Mirador Apartments.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "High-Speed Internet Apartments, Maricopa County",
      "seo_description": "Stay connected at Mirador Apartments in Maricopa County with free high-speed internet, modern amenities, and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "generator",
      "page_item_url": "units-private-patio-balcony-phoenix-az",
      "search_query": "units with private patio balcony Phoenix AZ",
      "category": "Amenity",
      "h1_title": "Units with Private Patio Balcony in Phoenix, AZ",
      "h2_subtitle": "Discover units with a private patio balcony in Phoenix, AZ. Enjoy serene outdoor spaces at Mirador.",
      "page_copy": "Experience outdoor serenity with units at Mirador in Phoenix, AZ that feature private patios and balconies. These outdoor retreats offer an ideal space for personal relaxation or entertaining guests while enjoying the scenic views of the Pointe Golf Club On Lookout Mountain neighborhood.\n\nMirador's prime location offers more than just picturesque views. Our apartments come equipped with modern conveniences, such as a full-size washer/dryer and Cox Quick Connect, ensuring easy living. With amenities like ceiling fans in the living rooms of select units and a month of free high-speed internet from Cox Communications, Mirador combines comfort with the outdoor freedom of a private patio or balcony. Dive into the vibrant community life in Maricopa County at Mirador Apartments.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Mirador Units with Private Patio Balcony, Phoenix",
      "seo_description": "Enjoy outdoor living at Mirador in Phoenix, AZ with units featuring a private patio or balcony. Experience the best of apartment life.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "generator",
      "page_item_url": "apartment-with-dishwasher-85022",
      "search_query": "apartment with dishwasher in 85022",
      "category": "Amenity",
      "h1_title": "Apartment with Dishwasher in 85022",
      "h2_subtitle": "Find an apartment with a dishwasher in the 85022 area. Discover the modern living at Mirador in Phoenix.",
      "page_copy": "Residents at Mirador enjoy a convenient lifestyle in the 85022 area with apartments equipped with modern amenities, including a dishwasher. This Phoenix community, located in the scenic Pointe Golf Club On Lookout Mountain, provides everything needed to make everyday tasks easier and freeing up time for what truly matters.\n\nIn addition to dishwashers, each apartment home features a full-size washer/dryer and a private patio/balcony, adding both comfort and functionality to your living space. With amenities like ceiling fans in select living rooms and high-speed internet provided by Cox Communications for the first month free, Mirador ensures a seamless living experience in Maricopa County. Discover the unique blend of convenience and style in your apartment at Mirador.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment with Dishwasher in 85022 at Mirador",
      "seo_description": "Enjoy a modern apartment with a dishwasher at Mirador in Phoenix's 85022 area, complete with premium amenities and great community living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "generator",
      "page_item_url": "full-size-washer-dryer-apartment-lookout-mountain",
      "search_query": "full size washer dryer apartment Lookout Mountain",
      "category": "Amenity",
      "h1_title": "Full Size Washer Dryer Apartments Lookout Mountain",
      "h2_subtitle": "Enjoy the convenience of a full size washer and dryer in our Lookout Mountain apartments, here at Mirador.",
      "page_copy": "Nestled in the picturesque Pointe Golf Club On Lookout Mountain neighborhood, Mirador offers apartments equipped with full size washer and dryer units. This essential home feature ensures ease of living, allowing you more time to savor the beauty of the surrounding Phoenix landscape and community.\n\nAt Mirador, residents experience not only the convenience of in-home laundry but also a host of other amenities designed for modern living. Enjoy private patios/balconies and ceiling fans in select living rooms, alongside the perks of Cox Quick Connect and a promotional month of free high-speed internet from Cox Communications. Embrace the tranquility and all-inclusive lifestyle at Mirador, located in the heart of Maricopa County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Mirador Full Size Washer Dryer Apartments",
      "seo_description": "Discover Mirador in Lookout Mountain with full size washer dryers, offering modern comforts in Phoenix, AZ.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-phoenix-az-mirador",
      "search_query": "one bedroom apartments phoenix az",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Phoenix, AZ",
      "h2_subtitle": "Explore our one bedroom apartments in Phoenix, AZ. Find the perfect home at Mirador, nestled in a vibrant neighborhood.",
      "page_copy": "Mirador offers an exceptional selection of one bedroom apartments in Phoenix, AZ, perfect for those seeking comfort and style. These thoughtfully designed units are set within the desirable Pointe Golf Club On Lookout Mountain area, providing the perfect blend of city living and scenic surroundings.\n\nEach one bedroom apartment at Mirador is equipped with essential amenities, such as a full size washer/dryer and private patio/balcony, ensuring a convenient lifestyle. With ceiling fans available in select living rooms and a month of complimentary high-speed internet courtesy of Cox Communications, Mirador combines modern living with comfort. Discover the vibrant community and unique lifestyle benefits of residing in Maricopa County at Mirador Apartments.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Mirador One Bedroom Apartments in Phoenix, AZ",
      "seo_description": "Discover one bedroom apartments at Mirador in Phoenix, AZ, offering modern amenities and scenic views in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-pointe-golf-club",
      "search_query": "two bedroom apartments near pointe golf club",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near Pointe Golf Club",
      "h2_subtitle": "Discover spacious two bedroom apartments near Pointe Golf Club. Enjoy serene living at Mirador in Phoenix.",
      "page_copy": "Mirador boasts spacious two bedroom apartments conveniently located near the scenic Pointe Golf Club On Lookout Mountain. Ideal for those seeking ample living space with modern conveniences, our apartments offer a tranquil retreat in Phoenix.\n\nEach apartment includes a full size washer/dryer and private patio/balcony, providing all the comforts of home. With features like ceiling fans in select living rooms and access to Cox Quick Connect, residents enjoy both comfort and connectivity. Plus, take advantage of a complimentary month of high-speed internet courtesy of Cox Communications. Experience the best of Phoenix living in Maricopa County at Mirador Apartments, where community and comfort come together.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Mirador Two Bedroom Apartments Near Pointe",
      "seo_description": "Find two bedroom apartments at Mirador near Pointe Golf Club, Phoenix, offering modern amenities in a scenic setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-maricopa-county-mirador",
      "search_query": "three bedroom apartments maricopa county",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Maricopa County",
      "h2_subtitle": "Explore our spacious three bedroom apartments in Maricopa County. Mirador offers comfort and convenience in a picturesque setting.",
      "page_copy": "At Mirador, we provide beautiful three bedroom apartments in desirable Maricopa County, uniquely blending style and practicality for any household. Our community, nestled near the Pointe Golf Club On Lookout Mountain, offers a serene yet connected lifestyle.\n\nThese spacious apartments feature a full size washer/dryer and a private patio/balcony, ensuring you enjoy both comfort and convenience. Select living rooms come with ceiling fans, and every home includes the benefit of a month of complimentary high-speed internet from Cox Communications. Set in vibrant Phoenix, Mirador combines a prime location with premium living experiences, making it the perfect choice for three bedroom homes.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Mirador Three Bedroom Apartments Maricopa",
      "seo_description": "Discover three bedroom apartments at Mirador in Maricopa County, offering modern amenities and a scenic location near Phoenix, AZ.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "generator",
      "page_item_url": "apartments-near-paradise-valley-community-college",
      "search_query": "apartments near paradise valley community college phoenix",
      "category": "School",
      "h1_title": "Apartments Near Paradise Valley Community College",
      "h2_subtitle": "Find the ideal apartments near Paradise Valley Community College. Mirador offers a perfect blend of convenience and comfort in Phoenix.",
      "page_copy": "Located in Phoenix, Mirador Apartments offer an excellent choice for those seeking living spaces close to Paradise Valley Community College. Perfectly situated in Maricopa County, our community allows easy access to educational opportunities while providing a peaceful retreat.\n\nResidents can enjoy a full range of amenities in our apartments, such as a full size washer/dryer and private patio/balcony. With the added benefits of ceiling fans in select living rooms and one month of free high-speed internet courtesy of Cox Communications, life at Mirador combines convenience with modern comforts. Experience ideal living close to Paradise Valley Community College in the vibrant setting of our community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Mirador Apartments Near Paradise Valley College",
      "seo_description": "Discover Mirador Apartments near Paradise Valley College in Phoenix. Enjoy modern amenities in a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "generator",
      "page_item_url": "apartments-near-honorhealth-deer-valley-medical-center",
      "search_query": "apartments near HonorHealth Deer Valley Medical Center Phoenix",
      "category": "Hospital",
      "h1_title": "Apartments Near HonorHealth Deer Valley",
      "h2_subtitle": "Mirador Apartments offer an ideal living space near HonorHealth Deer Valley Medical Center in Phoenix. Enjoy modern comforts and a great location.",
      "page_copy": "Mirador Apartments provides a perfect option for those seeking residences near HonorHealth Deer Valley Medical Center in Phoenix. Our community is designed to offer convenience while you balance work and lifestyle needs.\n\nFeaturing spacious apartments with full size washers/dryers and private patios/balconies, residents enjoy a comfortable living experience. Select units include ceiling fans for added comfort, and the added benefit of a month of complimentary high-speed internet through Cox Communications ensures you're always connected. Nestled in Maricopa County, Mirador becomes the ideal choice for those working or visiting HonorHealth Deer Valley Medical Center, offering a blend of accessibility and tranquility.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Mirador Apartments Near HonorHealth Deer Valley",
      "seo_description": "Discover Mirador Apartments near HonorHealth Deer Valley Medical Center in Phoenix, offering comfort, convenience, and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "generator",
      "page_item_url": "apartments-near-roadrunner-park-phoenix",
      "search_query": "apartments near roadrunner park phoenix",
      "category": "Park",
      "h1_title": "Apartments Near Roadrunner Park Phoenix",
      "h2_subtitle": "Explore Mirador Apartments near Roadrunner Park in Phoenix. Enjoy a vibrant community with modern amenities and a convenient location.",
      "page_copy": "Situated in the heart of Phoenix, Mirador Apartments offer the perfect mix of convenience and community for those who love being near Roadrunner Park. Whether you want to enjoy outdoor activities or need a serene living environment, our apartments deliver on all fronts.\n\nMirador provides residents with modern amenities, including a full size washer/dryer and private patios or balconies for outdoor relaxation. Some living rooms are equipped with ceiling fans for added comfort, and every resident benefits from a free month of high-speed internet through Cox Communications. Experience the vibrant energy of living near Roadrunner Park, with easy access to local recreational options and the comfort of a welcoming community at Mirador.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Mirador Apartments Near Roadrunner Park",
      "seo_description": "Discover Mirador Apartments near Roadrunner Park in Phoenix. Enjoy excellent amenities and a prime location ideal for active lifestyles.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "generator",
      "page_item_url": "granada-park-apartments-maricopa-county",
      "search_query": "granada park apartments in maricopa county",
      "category": "Park",
      "h1_title": "Granada Park Apartments in Maricopa County",
      "h2_subtitle": "Discover Mirador's proximity to Granada Park in Maricopa County. Our apartments offer modern amenities and a prime location.",
      "page_copy": "Nestled in Maricopa County, Mirador Apartments are an excellent choice for those seeking residences close to Granada Park. This strategic location provides an ideal balance of urban accessibility and scenic tranquility, perfect for those who appreciate the outdoors.\n\nMirador boasts a range of amenities such as full-size washers/dryers, private patios/balconies, and the option of ceiling fans in select living rooms. Plus, with a month of complimentary high-speed internet provided by Cox Communications, staying connected is effortless. Experience the convenience and lifestyle benefits of Maricopa County with the added charm of being near Granada Park, all from the comfort of Mirador Apartments.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Mirador Near Granada Park in Maricopa County",
      "seo_description": "Explore Mirador Apartments near Granada Park in Maricopa County. Enjoy modern living and a prime location with all the conveniences you need.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "generator",
      "page_item_url": "apartments-near-19th-ave-dunlap-phoenix",
      "search_query": "apartments near 19th Ave/Dunlap Phoenix",
      "category": "Transit",
      "h1_title": "Apartments Near 19th Ave/Dunlap Phoenix",
      "h2_subtitle": "Discover convenient living at Mirador Apartments near 19th Ave/Dunlap in Phoenix. Our community offers modern amenities and a prime location.",
      "page_copy": "Located close to 19th Ave/Dunlap in Phoenix, Mirador Apartments offer a blend of accessibility and comfort for those seeking a vibrant urban lifestyle. Enjoy easy access to this dynamic area, known for its diverse shopping, dining, and entertainment options.\n\nMirador is designed with resident convenience in mind, featuring full-size washers/dryers, private patios or balconies, and the availability of ceiling fans in select units. Enjoy a hassle-free lifestyle with a complimentary month of high-speed internet courtesy of Cox Communications. Whether you're commuting or exploring, Mirador Apartments offer a prime location near 19th Ave/Dunlap, ensuring you have everything you need at your doorstep.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Mirador Apartments Near 19th Ave/Dunlap",
      "seo_description": "Explore Mirador Apartments near 19th Ave/Dunlap in Phoenix. Offering modern amenities and a convenient location near shopping and dining.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "generator",
      "page_item_url": "apartments-close-to-metro-pkwy-maricopa-county",
      "search_query": "apartments close to Metro Pkwy Maricopa County",
      "category": "Transit",
      "h1_title": "Apartments Close to Metro Pkwy",
      "h2_subtitle": "Discover the convenience of living at Mirador, close to Metro Pkwy in Maricopa County. Enjoy modern amenities and excellent connectivity.",
      "page_copy": "Mirador Apartments, nestled in Maricopa County, provide an ideal living experience for those looking to stay close to Metro Parkway. This bustling area is known for its shopping, dining, and entertainment opportunities, making it a perfect spot for an active lifestyle.\n\nOur apartments offer a host of modern amenities, including full-size washers and dryers, private patios or balconies, and ceiling fans in select living rooms. Residents can also enjoy a complimentary month of high-speed internet from Cox Communications, ensuring seamless connectivity. Experience the vibrant life of Metro Pkwy while enjoying the comfort and convenience provided by Mirador Apartments.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Mirador Apartments Close to Metro Pkwy",
      "seo_description": "Explore Mirador Apartments close to Metro Pkwy in Maricopa County. Enjoy modern amenities and proximity to shopping and dining.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167149",
      "source": "generator",
      "page_item_url": "apartments-by-glendale-19th-ave-85022",
      "search_query": "apartments by Glendale/19th Ave 85022",
      "category": "Transit",
      "h1_title": "Apartments by Glendale/19th Ave in 85022",
      "h2_subtitle": "Explore the ideal location of Mirador Apartments by Glendale and 19th Ave in the 85022 area. Enjoy modern living in a convenient neighborhood.",
      "page_copy": "Mirador Apartments, situated in the heart of the 85022 ZIP code, are perfectly located near Glendale and 19th Ave. This area offers residents the convenience of nearby shopping centers, diverse dining options, and easy access to public transportation, making it an excellent place to call home.\n\nOur apartments feature comprehensive amenities like full-size washers and dryers, private patios or balconies, and the option of ceiling fans in the living room in select units. Additionally, Mirador residents benefit from a complimentary month of high-speed internet provided by Cox Communications. Experience the blend of convenience and comfort at Mirador Apartments, ideally situated by Glendale and 19th Ave.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Mirador Near Glendale/19th Ave in 85022",
      "seo_description": "Discover Mirador Apartments near Glendale and 19th Ave in 85022. Enjoy modern amenities and a convenient location close to shopping and transit.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11309011791"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=9283393406"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TJPHH2DT"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 5"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "36b3ac3b-14b6-4f8b-8d59-04cba681bfa0"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Vantage"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_pricing_verbiage",
      "type": "STRING",
      "value": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more."
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/546fc4ea-a86d-425a-84d0-e3da5e52b79a/app.js?property=546fc4ea-a86d-425a-84d0-e3da5e52b79a&propertyName=Mirador&channelUuid=c2490bb3-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47572542739"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImxOcWxjcmRUS3ViNTBOc3hKZ083eFE9PSIsInZhbHVlIjoiYktTV2VCd1Y0R0ZmSG4xYlhqT3lodz09IiwibWFjIjoiZTdhNjM0MWMzMTM2NWU0NDMzOWY0NTc1OTI1NjY5ZTkxMGRhODJhOWI5YmExYzgwZjNiMGQ2NWNiYTgyODJiMiJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11309011791",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=9283393406",
  "custom_google_gtm_id": "GTM-TJPHH2DT",
  "custom_rollout_phase": "Phase 5",
  "custom_rentgrata_token": "36b3ac3b-14b6-4f8b-8d59-04cba681bfa0",
  "custom_vibesites_theme": "Vantage",
  "custom_ads_subscription": "none",
  "custom_pricing_verbiage": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/546fc4ea-a86d-425a-84d0-e3da5e52b79a/app.js?property=546fc4ea-a86d-425a-84d0-e3da5e52b79a&propertyName=Mirador&channelUuid=c2490bb3-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47572542739",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImxOcWxjcmRUS3ViNTBOc3hKZ083eFE9PSIsInZhbHVlIjoiYktTV2VCd1Y0R0ZmSG4xYlhqT3lodz09IiwibWFjIjoiZTdhNjM0MWMzMTM2NWU0NDMzOWY0NTc1OTI1NjY5ZTkxMGRhODJhOWI5YmExYzgwZjNiMGQ2NWNiYTgyODJiMiJ9",
  "custom_audioeye_site_id": "63bfbdd0-bb35-4303-9186-7e185f5db14d",
  "custom_audioeye_site_hash": "3df3fb8ec9f8b252609a8756505fb651"
};

export const generatedAt = '2026-10-27T17:07:42.932Z';
